export const response = {
  legRequests: [
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:419767',
      flightRequestUrl: 'https://console.vista.studio/#fl:12771647',
      requestUrl: 'https://console.vista.studio/#l:12771648',
      flightRequestId: 12771647,
      legId: 419767,
      cateringCredit: {
        updateTime: null,
        cateringCreditId: 106,
        flightRequestId: 12771647,
        legId: 419767,
        amount: 0,
        clientId: 1705839,
        legRequestId: 12771648,
        createTime: '2022-03-24T10:52:28.154094+00:00',
      },
      flightRequest: {
        status: 101,
        updateTime: '2021-10-14T12:54:36.648332+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 18929.68,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/25269',
            createTime: '2021-10-14T12:52:59.765125+00:00',
            formUrlKey: '9498c9a5-5200-4559-938a-dedda689a93d',
            clientSource: '2',
            formTplId: 359,
            id: 591993,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?9498c9a5-5200-4559-938a-dedda689a93d',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?9498c9a5-5200-4559-938a-dedda689a93d',
          },
        ],
        orderItemTotal: 18929.68,
        invoiceData: null,
        departureDate: '2021-10-26T00:00:00',
        assignedOperator: 2040155,
        total: '18929.68',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"King Air 100","tailNumber":"N230FL","pax":2,"yom":1976,"safety_rating":{"argusSafety":"Gold","wyvernSafety":"Registered"},"price":17609,"taxes":{"fetTax":1320.6753488372094},"amount":null,"src":null,"operator":{"id":"922ab57a-020f-48f2-9f5c-3a41d502f726","name":"Maine Aviation Management Inc"},"reqLegData":[{"from":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-10-26T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":8772.5,"unitQuantity":1,"unitPercentage":null,"amount":8772.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":8772.5,"unitQuantity":null,"unitPercentage":7.5,"amount":657.94,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":8,"unitPercentage":null,"amount":34.4,"currency":"USD"}],"eft":3},{"from":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-10-28T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":8772.5,"unitQuantity":1,"unitPercentage":null,"amount":8772.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":8772.5,"unitQuantity":null,"unitPercentage":7.5,"amount":657.94,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":8,"unitPercentage":null,"amount":34.4,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KLAX","destination":"KSFO","departing":"2021-10-26T07:00:00.000Z","departingLocal":"2021-10-26T00:00:00.000Z","arrivingLocal":"2021-10-26T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KSFO","destination":"KLAX","departing":"2021-10-28T07:00:00.000Z","departingLocal":"2021-10-28T00:00:00.000Z","arrivingLocal":"2021-10-28T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":17609,"nonMemberPrice":17609,"original_price":17609,"sFtime":"0:06","origRequest":{"legFwd":419767,"legIDs":[419767,419768],"legRet":419768}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KLAX.KSFO.21.10.26.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '9edfc91d-4658-4f98-8f0b-0c0b5bddd41a',
        requestId: 12771647,
        invoiceState: null,
        searchParams:
          '{"seg":["KLAX.KSFO.21.10.26.00.00","KSFO.KLAX.21.10.28.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: '56bf3339-4aac-451e-9933-1bcab808b0ec',
        requestUrl: 'https://console.vista.studio/#fl:12771647',
        requestTime: '2021-10-14T12:52:53.507868+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 5,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2021-10-26T07:00:00+00:00',
      clientId: 1705839,
      requestId: 12771648,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:419768',
      flightRequestUrl: 'https://console.vista.studio/#fl:12771647',
      requestUrl: 'https://console.vista.studio/#l:12771649',
      flightRequestId: 12771647,
      legId: 419768,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12771647,
        clientId: 1705839,
        amount: 250,
        legId: 419768,
        legRequestId: 12771649,
      },
      flightRequest: {
        status: 101,
        updateTime: '2021-10-14T12:54:36.648332+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 18929.68,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/25269',
            createTime: '2021-10-14T12:52:59.765125+00:00',
            formUrlKey: '9498c9a5-5200-4559-938a-dedda689a93d',
            clientSource: '2',
            formTplId: 359,
            id: 591993,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?9498c9a5-5200-4559-938a-dedda689a93d',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?9498c9a5-5200-4559-938a-dedda689a93d',
          },
        ],
        orderItemTotal: 18929.68,
        invoiceData: null,
        departureDate: '2021-10-26T00:00:00',
        assignedOperator: 2040155,
        total: '18929.68',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"King Air 100","tailNumber":"N230FL","pax":2,"yom":1976,"safety_rating":{"argusSafety":"Gold","wyvernSafety":"Registered"},"price":17609,"taxes":{"fetTax":1320.6753488372094},"amount":null,"src":null,"operator":{"id":"922ab57a-020f-48f2-9f5c-3a41d502f726","name":"Maine Aviation Management Inc"},"reqLegData":[{"from":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-10-26T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":8772.5,"unitQuantity":1,"unitPercentage":null,"amount":8772.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":8772.5,"unitQuantity":null,"unitPercentage":7.5,"amount":657.94,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":8,"unitPercentage":null,"amount":34.4,"currency":"USD"}],"eft":3},{"from":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-10-28T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":8772.5,"unitQuantity":1,"unitPercentage":null,"amount":8772.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":8772.5,"unitQuantity":null,"unitPercentage":7.5,"amount":657.94,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":8,"unitPercentage":null,"amount":34.4,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KLAX","destination":"KSFO","departing":"2021-10-26T07:00:00.000Z","departingLocal":"2021-10-26T00:00:00.000Z","arrivingLocal":"2021-10-26T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KSFO","destination":"KLAX","departing":"2021-10-28T07:00:00.000Z","departingLocal":"2021-10-28T00:00:00.000Z","arrivingLocal":"2021-10-28T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":17609,"nonMemberPrice":17609,"original_price":17609,"sFtime":"0:06","origRequest":{"legFwd":419767,"legIDs":[419767,419768],"legRet":419768}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KLAX.KSFO.21.10.26.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '9edfc91d-4658-4f98-8f0b-0c0b5bddd41a',
        requestId: 12771647,
        invoiceState: null,
        searchParams:
          '{"seg":["KLAX.KSFO.21.10.26.00.00","KSFO.KLAX.21.10.28.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: '56bf3339-4aac-451e-9933-1bcab808b0ec',
        requestUrl: 'https://console.vista.studio/#fl:12771647',
        requestTime: '2021-10-14T12:52:53.507868+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 5,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2021-10-28T07:00:00+00:00',
      clientId: 1705839,
      requestId: 12771649,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:419791',
      flightRequestUrl: 'https://console.vista.studio/#fl:12771709',
      requestUrl: 'https://console.vista.studio/#l:12771711',
      flightRequestId: 12771709,
      legId: 419791,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12771709,
        clientId: 1705839,
        amount: 250,
        legId: 419791,
        legRequestId: 12771711,
      },
      flightRequest: {
        status: 101,
        updateTime: '2021-10-14T19:10:36.979807+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 18929.68,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/25273',
            createTime: '2021-10-14T19:08:32.322799+00:00',
            formUrlKey: '07d39b6e-fb73-472c-8fa8-2da8d0548332',
            clientSource: '2',
            formTplId: 359,
            id: 592021,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?07d39b6e-fb73-472c-8fa8-2da8d0548332',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?07d39b6e-fb73-472c-8fa8-2da8d0548332',
          },
        ],
        orderItemTotal: 18929.68,
        invoiceData: null,
        departureDate: '2021-10-26T00:00:00',
        assignedOperator: 2040155,
        total: '18929.68',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"King Air 100","tailNumber":"N230FL","pax":2,"yom":1976,"safety_rating":{"argusSafety":"Gold","wyvernSafety":"Registered"},"price":17609,"taxes":{"fetTax":1320.6753488372094},"amount":null,"src":null,"operator":{"id":"922ab57a-020f-48f2-9f5c-3a41d502f726","name":"Maine Aviation Management Inc"},"reqLegData":[{"from":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-10-26T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":8772.5,"unitQuantity":1,"unitPercentage":null,"amount":8772.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":8772.5,"unitQuantity":null,"unitPercentage":7.5,"amount":657.94,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":8,"unitPercentage":null,"amount":34.4,"currency":"USD"}],"eft":3},{"from":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-10-28T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":8772.5,"unitQuantity":1,"unitPercentage":null,"amount":8772.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":8772.5,"unitQuantity":null,"unitPercentage":7.5,"amount":657.94,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":8,"unitPercentage":null,"amount":34.4,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KLAX","destination":"KSFO","departing":"2021-10-26T07:00:00.000Z","departingLocal":"2021-10-26T00:00:00.000Z","arrivingLocal":"2021-10-26T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KSFO","destination":"KLAX","departing":"2021-10-28T07:00:00.000Z","departingLocal":"2021-10-28T00:00:00.000Z","arrivingLocal":"2021-10-28T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":17609,"nonMemberPrice":17609,"original_price":17609,"sFtime":"0:06","origRequest":{"legFwd":419791,"legIDs":[419791,419792],"legRet":419792}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KLAX.KSFO.21.10.26.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: 'dc4958df-049a-4b9c-a390-a59e29474658',
        requestId: 12771709,
        invoiceState: null,
        searchParams:
          '{"seg":["KLAX.KSFO.21.10.26.00.00","KSFO.KLAX.21.10.28.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: '56bf3339-4aac-451e-9933-1bcab808b0ec',
        requestUrl: 'https://console.vista.studio/#fl:12771709',
        requestTime: '2021-10-14T19:08:24.643747+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 5,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2021-10-26T07:00:00+00:00',
      clientId: 1705839,
      requestId: 12771711,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:419792',
      flightRequestUrl: 'https://console.vista.studio/#fl:12771709',
      requestUrl: 'https://console.vista.studio/#l:12771712',
      flightRequestId: 12771709,
      legId: 419792,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12771709,
        clientId: 1705839,
        amount: 250,
        legId: 419792,
        legRequestId: 12771712,
      },
      flightRequest: {
        status: 101,
        updateTime: '2021-10-14T19:10:36.979807+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 18929.68,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/25273',
            createTime: '2021-10-14T19:08:32.322799+00:00',
            formUrlKey: '07d39b6e-fb73-472c-8fa8-2da8d0548332',
            clientSource: '2',
            formTplId: 359,
            id: 592021,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?07d39b6e-fb73-472c-8fa8-2da8d0548332',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?07d39b6e-fb73-472c-8fa8-2da8d0548332',
          },
        ],
        orderItemTotal: 18929.68,
        invoiceData: null,
        departureDate: '2021-10-26T00:00:00',
        assignedOperator: 2040155,
        total: '18929.68',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"King Air 100","tailNumber":"N230FL","pax":2,"yom":1976,"safety_rating":{"argusSafety":"Gold","wyvernSafety":"Registered"},"price":17609,"taxes":{"fetTax":1320.6753488372094},"amount":null,"src":null,"operator":{"id":"922ab57a-020f-48f2-9f5c-3a41d502f726","name":"Maine Aviation Management Inc"},"reqLegData":[{"from":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-10-26T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":8772.5,"unitQuantity":1,"unitPercentage":null,"amount":8772.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":8772.5,"unitQuantity":null,"unitPercentage":7.5,"amount":657.94,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":8,"unitPercentage":null,"amount":34.4,"currency":"USD"}],"eft":3},{"from":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-10-28T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":8772.5,"unitQuantity":1,"unitPercentage":null,"amount":8772.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":8772.5,"unitQuantity":null,"unitPercentage":7.5,"amount":657.94,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":8,"unitPercentage":null,"amount":34.4,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KLAX","destination":"KSFO","departing":"2021-10-26T07:00:00.000Z","departingLocal":"2021-10-26T00:00:00.000Z","arrivingLocal":"2021-10-26T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KSFO","destination":"KLAX","departing":"2021-10-28T07:00:00.000Z","departingLocal":"2021-10-28T00:00:00.000Z","arrivingLocal":"2021-10-28T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":17609,"nonMemberPrice":17609,"original_price":17609,"sFtime":"0:06","origRequest":{"legFwd":419791,"legIDs":[419791,419792],"legRet":419792}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KLAX.KSFO.21.10.26.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: 'dc4958df-049a-4b9c-a390-a59e29474658',
        requestId: 12771709,
        invoiceState: null,
        searchParams:
          '{"seg":["KLAX.KSFO.21.10.26.00.00","KSFO.KLAX.21.10.28.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: '56bf3339-4aac-451e-9933-1bcab808b0ec',
        requestUrl: 'https://console.vista.studio/#fl:12771709',
        requestTime: '2021-10-14T19:08:24.643747+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 5,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2021-10-28T07:00:00+00:00',
      clientId: 1705839,
      requestId: 12771712,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:419856',
      flightRequestUrl: 'https://console.vista.studio/#fl:12771894',
      requestUrl: 'https://console.vista.studio/#l:12771895',
      flightRequestId: 12771894,
      legId: 419856,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12771894,
        clientId: 1705839,
        amount: 250,
        legId: 419856,
        legRequestId: 12771895,
      },
      flightRequest: {
        status: 101,
        updateTime: '2021-10-15T13:14:39.713549+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 18929.68,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/25280',
            createTime: '2021-10-15T13:10:53.134531+00:00',
            formUrlKey: '63267ef8-fa32-4c14-8b3a-2771115ac3d1',
            clientSource: '2',
            formTplId: 359,
            id: 592077,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?63267ef8-fa32-4c14-8b3a-2771115ac3d1',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?63267ef8-fa32-4c14-8b3a-2771115ac3d1',
          },
        ],
        orderItemTotal: 18929.68,
        invoiceData: null,
        departureDate: '2021-10-26T00:00:00',
        assignedOperator: 2040155,
        total: '18929.68',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"King Air 100","tailNumber":"N230FL","pax":2,"yom":1976,"safety_rating":{"argusSafety":"Gold","wyvernSafety":"Registered"},"price":17609,"taxes":{"fetTax":1320.6753488372094},"amount":null,"src":null,"operator":{"id":"922ab57a-020f-48f2-9f5c-3a41d502f726","name":"Maine Aviation Management Inc"},"reqLegData":[{"from":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-10-26T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":8772.5,"unitQuantity":1,"unitPercentage":null,"amount":8772.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":8772.5,"unitQuantity":null,"unitPercentage":7.5,"amount":657.94,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":8,"unitPercentage":null,"amount":34.4,"currency":"USD"}],"eft":3},{"from":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-10-28T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":8772.5,"unitQuantity":1,"unitPercentage":null,"amount":8772.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":8772.5,"unitQuantity":null,"unitPercentage":7.5,"amount":657.94,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":8,"unitPercentage":null,"amount":34.4,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KLAX","destination":"KSFO","departing":"2021-10-26T07:00:00.000Z","departingLocal":"2021-10-26T00:00:00.000Z","arrivingLocal":"2021-10-26T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KSFO","destination":"KLAX","departing":"2021-10-28T07:00:00.000Z","departingLocal":"2021-10-28T00:00:00.000Z","arrivingLocal":"2021-10-28T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":17609,"nonMemberPrice":17609,"original_price":17609,"sFtime":"0:06","origRequest":{"legFwd":419856,"legIDs":[419856,419857],"legRet":419857}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KLAX.KSFO.21.10.26.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: 'ee04b4eb-5be5-4f93-8c28-9a72522c70ca',
        requestId: 12771894,
        invoiceState: null,
        searchParams:
          '{"seg":["KLAX.KSFO.21.10.26.00.00","KSFO.KLAX.21.10.28.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: '56bf3339-4aac-451e-9933-1bcab808b0ec',
        requestUrl: 'https://console.vista.studio/#fl:12771894',
        requestTime: '2021-10-15T13:10:45.800944+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 5,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2021-10-26T07:00:00+00:00',
      clientId: 1705839,
      requestId: 12771895,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:419857',
      flightRequestUrl: 'https://console.vista.studio/#fl:12771894',
      requestUrl: 'https://console.vista.studio/#l:12771896',
      flightRequestId: 12771894,
      legId: 419857,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12771894,
        clientId: 1705839,
        amount: 250,
        legId: 419857,
        legRequestId: 12771896,
      },
      flightRequest: {
        status: 101,
        updateTime: '2021-10-15T13:14:39.713549+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 18929.68,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/25280',
            createTime: '2021-10-15T13:10:53.134531+00:00',
            formUrlKey: '63267ef8-fa32-4c14-8b3a-2771115ac3d1',
            clientSource: '2',
            formTplId: 359,
            id: 592077,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?63267ef8-fa32-4c14-8b3a-2771115ac3d1',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?63267ef8-fa32-4c14-8b3a-2771115ac3d1',
          },
        ],
        orderItemTotal: 18929.68,
        invoiceData: null,
        departureDate: '2021-10-26T00:00:00',
        assignedOperator: 2040155,
        total: '18929.68',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"King Air 100","tailNumber":"N230FL","pax":2,"yom":1976,"safety_rating":{"argusSafety":"Gold","wyvernSafety":"Registered"},"price":17609,"taxes":{"fetTax":1320.6753488372094},"amount":null,"src":null,"operator":{"id":"922ab57a-020f-48f2-9f5c-3a41d502f726","name":"Maine Aviation Management Inc"},"reqLegData":[{"from":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-10-26T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":8772.5,"unitQuantity":1,"unitPercentage":null,"amount":8772.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":8772.5,"unitQuantity":null,"unitPercentage":7.5,"amount":657.94,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":8,"unitPercentage":null,"amount":34.4,"currency":"USD"}],"eft":3},{"from":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-10-28T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":8772.5,"unitQuantity":1,"unitPercentage":null,"amount":8772.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":8772.5,"unitQuantity":null,"unitPercentage":7.5,"amount":657.94,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":8,"unitPercentage":null,"amount":34.4,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KLAX","destination":"KSFO","departing":"2021-10-26T07:00:00.000Z","departingLocal":"2021-10-26T00:00:00.000Z","arrivingLocal":"2021-10-26T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KSFO","destination":"KLAX","departing":"2021-10-28T07:00:00.000Z","departingLocal":"2021-10-28T00:00:00.000Z","arrivingLocal":"2021-10-28T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":17609,"nonMemberPrice":17609,"original_price":17609,"sFtime":"0:06","origRequest":{"legFwd":419856,"legIDs":[419856,419857],"legRet":419857}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KLAX.KSFO.21.10.26.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: 'ee04b4eb-5be5-4f93-8c28-9a72522c70ca',
        requestId: 12771894,
        invoiceState: null,
        searchParams:
          '{"seg":["KLAX.KSFO.21.10.26.00.00","KSFO.KLAX.21.10.28.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: '56bf3339-4aac-451e-9933-1bcab808b0ec',
        requestUrl: 'https://console.vista.studio/#fl:12771894',
        requestTime: '2021-10-15T13:10:45.800944+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 5,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2021-10-28T07:00:00+00:00',
      clientId: 1705839,
      requestId: 12771896,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:419864',
      flightRequestUrl: 'https://console.vista.studio/#fl:12771921',
      requestUrl: 'https://console.vista.studio/#l:12771922',
      flightRequestId: 12771921,
      legId: 419864,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12771921,
        clientId: 1705839,
        amount: 250,
        legId: 419864,
        legRequestId: 12771922,
      },
      flightRequest: {
        status: 101,
        updateTime: '2021-10-15T14:05:40.738270+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 18929.68,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/25284',
            createTime: '2021-10-15T14:04:20.030445+00:00',
            formUrlKey: 'bb80f6a5-7485-4555-923e-f95d1b036e6e',
            clientSource: '2',
            formTplId: 359,
            id: 592083,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?bb80f6a5-7485-4555-923e-f95d1b036e6e',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?bb80f6a5-7485-4555-923e-f95d1b036e6e',
          },
          {
            totalPrice: 18929.68,
            orderPaymentStatus: 6,
            orderUrl: 'http://localhost:3000/sales/orders/29175',
            createTime: '2022-03-23T13:57:50.757660+00:00',
            formUrlKey: '1fa8ed22-2f32-42f9-b8f2-624ad8a207a8',
            clientSource: '2',
            formTplId: 362,
            id: 598220,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?1fa8ed22-2f32-42f9-b8f2-624ad8a207a8',
            invoicePaymentStatus: 2,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/?1fa8ed22-2f32-42f9-b8f2-624ad8a207a8',
          },
        ],
        orderItemTotal: 18929.68,
        invoiceData: null,
        departureDate: '2021-10-26T00:00:00',
        assignedOperator: 2040155,
        total: '18929.68',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"King Air 100","tailNumber":"N230FL","pax":2,"yom":1976,"safety_rating":{"argusSafety":"Gold","wyvernSafety":"Registered"},"price":17609,"taxes":{"fetTax":1320.6753488372094},"amount":null,"src":null,"operator":{"id":"922ab57a-020f-48f2-9f5c-3a41d502f726","name":"Maine Aviation Management Inc"},"reqLegData":[{"from":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-10-26T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":8772.5,"unitQuantity":1,"unitPercentage":null,"amount":8772.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":8772.5,"unitQuantity":null,"unitPercentage":7.5,"amount":657.94,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":8,"unitPercentage":null,"amount":34.4,"currency":"USD"}],"eft":3},{"from":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-10-28T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":8772.5,"unitQuantity":1,"unitPercentage":null,"amount":8772.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":8772.5,"unitQuantity":null,"unitPercentage":7.5,"amount":657.94,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":8,"unitPercentage":null,"amount":34.4,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KLAX","destination":"KSFO","departing":"2021-10-26T07:00:00.000Z","departingLocal":"2021-10-26T00:00:00.000Z","arrivingLocal":"2021-10-26T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KSFO","destination":"KLAX","departing":"2021-10-28T07:00:00.000Z","departingLocal":"2021-10-28T00:00:00.000Z","arrivingLocal":"2021-10-28T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":17609,"nonMemberPrice":17609,"original_price":17609,"sFtime":"0:06","origRequest":{"legFwd":419864,"legIDs":[419864,419865],"legRet":419865}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KLAX.KSFO.21.10.26.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: 'd03719c2-8d12-4f84-9aa6-9d8cdbacc29d',
        requestId: 12771921,
        invoiceState: null,
        searchParams:
          '{"seg":["KLAX.KSFO.21.10.26.00.00","KSFO.KLAX.21.10.28.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: '56bf3339-4aac-451e-9933-1bcab808b0ec',
        requestUrl: 'https://console.vista.studio/#fl:12771921',
        requestTime: '2021-10-15T14:04:12.660802+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 3,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2021-10-26T07:00:00+00:00',
      clientId: 1705839,
      requestId: 12771922,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:419865',
      flightRequestUrl: 'https://console.vista.studio/#fl:12771921',
      requestUrl: 'https://console.vista.studio/#l:12771923',
      flightRequestId: 12771921,
      legId: 419865,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12771921,
        clientId: 1705839,
        amount: 250,
        legId: 419865,
        legRequestId: 12771923,
      },
      flightRequest: {
        status: 101,
        updateTime: '2021-10-15T14:05:40.738270+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 18929.68,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/25284',
            createTime: '2021-10-15T14:04:20.030445+00:00',
            formUrlKey: 'bb80f6a5-7485-4555-923e-f95d1b036e6e',
            clientSource: '2',
            formTplId: 359,
            id: 592083,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?bb80f6a5-7485-4555-923e-f95d1b036e6e',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?bb80f6a5-7485-4555-923e-f95d1b036e6e',
          },
          {
            totalPrice: 18929.68,
            orderPaymentStatus: 6,
            orderUrl: 'http://localhost:3000/sales/orders/29175',
            createTime: '2022-03-23T13:57:50.757660+00:00',
            formUrlKey: '1fa8ed22-2f32-42f9-b8f2-624ad8a207a8',
            clientSource: '2',
            formTplId: 362,
            id: 598220,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?1fa8ed22-2f32-42f9-b8f2-624ad8a207a8',
            invoicePaymentStatus: 2,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/?1fa8ed22-2f32-42f9-b8f2-624ad8a207a8',
          },
        ],
        orderItemTotal: 18929.68,
        invoiceData: null,
        departureDate: '2021-10-26T00:00:00',
        assignedOperator: 2040155,
        total: '18929.68',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"King Air 100","tailNumber":"N230FL","pax":2,"yom":1976,"safety_rating":{"argusSafety":"Gold","wyvernSafety":"Registered"},"price":17609,"taxes":{"fetTax":1320.6753488372094},"amount":null,"src":null,"operator":{"id":"922ab57a-020f-48f2-9f5c-3a41d502f726","name":"Maine Aviation Management Inc"},"reqLegData":[{"from":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-10-26T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":8772.5,"unitQuantity":1,"unitPercentage":null,"amount":8772.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":8772.5,"unitQuantity":null,"unitPercentage":7.5,"amount":657.94,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":8,"unitPercentage":null,"amount":34.4,"currency":"USD"}],"eft":3},{"from":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-10-28T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":8772.5,"unitQuantity":1,"unitPercentage":null,"amount":8772.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":8772.5,"unitQuantity":null,"unitPercentage":7.5,"amount":657.94,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":8,"unitPercentage":null,"amount":34.4,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KLAX","destination":"KSFO","departing":"2021-10-26T07:00:00.000Z","departingLocal":"2021-10-26T00:00:00.000Z","arrivingLocal":"2021-10-26T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KSFO","destination":"KLAX","departing":"2021-10-28T07:00:00.000Z","departingLocal":"2021-10-28T00:00:00.000Z","arrivingLocal":"2021-10-28T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":17609,"nonMemberPrice":17609,"original_price":17609,"sFtime":"0:06","origRequest":{"legFwd":419864,"legIDs":[419864,419865],"legRet":419865}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KLAX.KSFO.21.10.26.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: 'd03719c2-8d12-4f84-9aa6-9d8cdbacc29d',
        requestId: 12771921,
        invoiceState: null,
        searchParams:
          '{"seg":["KLAX.KSFO.21.10.26.00.00","KSFO.KLAX.21.10.28.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: '56bf3339-4aac-451e-9933-1bcab808b0ec',
        requestUrl: 'https://console.vista.studio/#fl:12771921',
        requestTime: '2021-10-15T14:04:12.660802+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 3,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2021-10-28T07:00:00+00:00',
      clientId: 1705839,
      requestId: 12771923,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:420449',
      flightRequestUrl: 'https://console.vista.studio/#fl:12772332',
      requestUrl: 'https://console.vista.studio/#l:12772660',
      flightRequestId: 12772332,
      legId: 420449,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12772332,
        clientId: 1705839,
        amount: 250,
        legId: 420449,
        legRequestId: 12772660,
      },
      flightRequest: {
        status: 101,
        updateTime: '2021-10-26T22:42:20.017658+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 13518.12,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/25360',
            createTime: '2021-10-21T04:32:33.211428+00:00',
            formUrlKey: 'eebe2ec0-e42a-427c-b7b1-e6b6cf1f4787',
            clientSource: '2',
            formTplId: 359,
            id: 592267,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?eebe2ec0-e42a-427c-b7b1-e6b6cf1f4787',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?eebe2ec0-e42a-427c-b7b1-e6b6cf1f4787',
          },
        ],
        orderItemTotal: 13518.12,
        invoiceData: null,
        departureDate: '2021-11-10T00:00:00',
        assignedOperator: 2040155,
        total: '13518.12',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"Falcon 2000","tailNumber":"N234FJ","pax":2,"yom":1996,"safety_rating":{"argusSafety":"Platinum","wyvernSafety":"Wingman"},"price":12574.99,"taxes":{"fetTax":943.1246511627908},"amount":null,"src":null,"operator":{"id":"4a922f6c-92c2-4137-8e62-b4e4e0efaabd","name":"MAINE AVIATION AIRCRAFT CHARTER LLC"},"reqLegData":[{"from":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-10T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":6247.5,"unitQuantity":1,"unitPercentage":null,"amount":6247.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":6247.5,"unitQuantity":null,"unitPercentage":7.5,"amount":468.56,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3},{"from":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-12T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":6247.5,"unitQuantity":1,"unitPercentage":null,"amount":6247.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":6247.5,"unitQuantity":null,"unitPercentage":7.5,"amount":468.56,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KSFO","destination":"KLAX","departing":"2021-11-10T08:00:00.000Z","departingLocal":"2021-11-10T00:00:00.000Z","arrivingLocal":"2021-11-10T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KLAX","destination":"KSFO","departing":"2021-11-12T08:00:00.000Z","departingLocal":"2021-11-12T00:00:00.000Z","arrivingLocal":"2021-11-12T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":12574.99,"nonMemberPrice":12574.99,"original_price":12574.99,"sFtime":"0:06","origRequest":{"legFwd":420449,"legIDs":[420449,420450],"legRet":420450}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KSFO.KLAX.21.11.10.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: 'c396233a-fceb-4ff6-bc63-3153d91f6f1a',
        requestId: 12772332,
        invoiceState: null,
        searchParams:
          '{"seg":["KSFO.KLAX.21.11.10.00.00","KLAX.KSFO.21.11.12.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: '0f2b0235-bd5a-4e80-ae72-f390be4c55e6',
        requestUrl: 'https://console.vista.studio/#fl:12772332',
        requestTime: '2021-10-21T04:32:28.008464+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 5,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2021-11-10T08:00:00+00:00',
      clientId: 1705839,
      requestId: 12772660,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:420450',
      flightRequestUrl: 'https://console.vista.studio/#fl:12772332',
      requestUrl: 'https://console.vista.studio/#l:12772661',
      flightRequestId: 12772332,
      legId: 420450,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12772332,
        clientId: 1705839,
        amount: 250,
        legId: 420450,
        legRequestId: 12772661,
      },
      flightRequest: {
        status: 101,
        updateTime: '2021-10-26T22:42:20.017658+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 13518.12,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/25360',
            createTime: '2021-10-21T04:32:33.211428+00:00',
            formUrlKey: 'eebe2ec0-e42a-427c-b7b1-e6b6cf1f4787',
            clientSource: '2',
            formTplId: 359,
            id: 592267,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?eebe2ec0-e42a-427c-b7b1-e6b6cf1f4787',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?eebe2ec0-e42a-427c-b7b1-e6b6cf1f4787',
          },
        ],
        orderItemTotal: 13518.12,
        invoiceData: null,
        departureDate: '2021-11-10T00:00:00',
        assignedOperator: 2040155,
        total: '13518.12',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"Falcon 2000","tailNumber":"N234FJ","pax":2,"yom":1996,"safety_rating":{"argusSafety":"Platinum","wyvernSafety":"Wingman"},"price":12574.99,"taxes":{"fetTax":943.1246511627908},"amount":null,"src":null,"operator":{"id":"4a922f6c-92c2-4137-8e62-b4e4e0efaabd","name":"MAINE AVIATION AIRCRAFT CHARTER LLC"},"reqLegData":[{"from":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-10T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":6247.5,"unitQuantity":1,"unitPercentage":null,"amount":6247.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":6247.5,"unitQuantity":null,"unitPercentage":7.5,"amount":468.56,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3},{"from":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-12T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":6247.5,"unitQuantity":1,"unitPercentage":null,"amount":6247.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":6247.5,"unitQuantity":null,"unitPercentage":7.5,"amount":468.56,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KSFO","destination":"KLAX","departing":"2021-11-10T08:00:00.000Z","departingLocal":"2021-11-10T00:00:00.000Z","arrivingLocal":"2021-11-10T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KLAX","destination":"KSFO","departing":"2021-11-12T08:00:00.000Z","departingLocal":"2021-11-12T00:00:00.000Z","arrivingLocal":"2021-11-12T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":12574.99,"nonMemberPrice":12574.99,"original_price":12574.99,"sFtime":"0:06","origRequest":{"legFwd":420449,"legIDs":[420449,420450],"legRet":420450}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KSFO.KLAX.21.11.10.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: 'c396233a-fceb-4ff6-bc63-3153d91f6f1a',
        requestId: 12772332,
        invoiceState: null,
        searchParams:
          '{"seg":["KSFO.KLAX.21.11.10.00.00","KLAX.KSFO.21.11.12.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: '0f2b0235-bd5a-4e80-ae72-f390be4c55e6',
        requestUrl: 'https://console.vista.studio/#fl:12772332',
        requestTime: '2021-10-21T04:32:28.008464+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 5,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2021-11-12T08:00:00+00:00',
      clientId: 1705839,
      requestId: 12772661,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:420506',
      flightRequestUrl: 'https://console.vista.studio/#fl:12772723',
      requestUrl: 'https://console.vista.studio/#l:12772725',
      flightRequestId: 12772723,
      legId: 420506,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12772723,
        clientId: 1705839,
        amount: 250,
        legId: 420506,
        legRequestId: 12772725,
      },
      flightRequest: {
        status: 101,
        updateTime: '2021-10-27T20:18:26.789720+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 12765.62,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/25402',
            createTime: '2021-10-27T18:31:25.613744+00:00',
            formUrlKey: 'c5256d08-4bb7-4d32-b428-3d33c0170892',
            clientSource: '2',
            formTplId: 359,
            id: 592389,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?c5256d08-4bb7-4d32-b428-3d33c0170892',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?c5256d08-4bb7-4d32-b428-3d33c0170892',
          },
        ],
        orderItemTotal: 12765.62,
        invoiceData: null,
        departureDate: '2021-11-10T00:00:00',
        assignedOperator: 2040155,
        total: '12765.62',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"Falcon 2000","tailNumber":"N234FJ","pax":2,"yom":1996,"safety_rating":{"argusSafety":"Platinum","wyvernSafety":"Wingman"},"price":11874.99,"taxes":{"fetTax":890.6246511627908},"amount":null,"src":null,"operator":{"id":"4a922f6c-92c2-4137-8e62-b4e4e0efaabd","name":"MAINE AVIATION AIRCRAFT CHARTER LLC"},"reqLegData":[{"from":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-10T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":5897.5,"unitQuantity":1,"unitPercentage":null,"amount":5897.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":5897.5,"unitQuantity":null,"unitPercentage":7.5,"amount":442.31,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3},{"from":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-12T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":5897.5,"unitQuantity":1,"unitPercentage":null,"amount":5897.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":5897.5,"unitQuantity":null,"unitPercentage":7.5,"amount":442.31,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KSFO","destination":"KLAX","departing":"2021-11-10T08:00:00.000Z","departingLocal":"2021-11-10T00:00:00.000Z","arrivingLocal":"2021-11-10T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KLAX","destination":"KSFO","departing":"2021-11-12T08:00:00.000Z","departingLocal":"2021-11-12T00:00:00.000Z","arrivingLocal":"2021-11-12T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":11874.99,"nonMemberPrice":11874.99,"original_price":11874.99,"sFtime":"0:06","origRequest":{"legFwd":420506,"legIDs":[420506,420507],"legRet":420507}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KSFO.KLAX.21.11.10.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '1688f858-5cde-4995-a4cf-45d68fabac38',
        requestId: 12772723,
        invoiceState: null,
        searchParams:
          '{"seg":["KSFO.KLAX.21.11.10.00.00","KLAX.KSFO.21.11.12.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: '0f2b0235-bd5a-4e80-ae72-f390be4c55e6',
        requestUrl: 'https://console.vista.studio/#fl:12772723',
        requestTime: '2021-10-27T18:31:16.744939+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 5,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2021-11-10T08:00:00+00:00',
      clientId: 1705839,
      requestId: 12772725,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:420507',
      flightRequestUrl: 'https://console.vista.studio/#fl:12772723',
      requestUrl: 'https://console.vista.studio/#l:12772726',
      flightRequestId: 12772723,
      legId: 420507,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12772723,
        clientId: 1705839,
        amount: 250,
        legId: 420507,
        legRequestId: 12772726,
      },
      flightRequest: {
        status: 101,
        updateTime: '2021-10-27T20:18:26.789720+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 12765.62,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/25402',
            createTime: '2021-10-27T18:31:25.613744+00:00',
            formUrlKey: 'c5256d08-4bb7-4d32-b428-3d33c0170892',
            clientSource: '2',
            formTplId: 359,
            id: 592389,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?c5256d08-4bb7-4d32-b428-3d33c0170892',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?c5256d08-4bb7-4d32-b428-3d33c0170892',
          },
        ],
        orderItemTotal: 12765.62,
        invoiceData: null,
        departureDate: '2021-11-10T00:00:00',
        assignedOperator: 2040155,
        total: '12765.62',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"Falcon 2000","tailNumber":"N234FJ","pax":2,"yom":1996,"safety_rating":{"argusSafety":"Platinum","wyvernSafety":"Wingman"},"price":11874.99,"taxes":{"fetTax":890.6246511627908},"amount":null,"src":null,"operator":{"id":"4a922f6c-92c2-4137-8e62-b4e4e0efaabd","name":"MAINE AVIATION AIRCRAFT CHARTER LLC"},"reqLegData":[{"from":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-10T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":5897.5,"unitQuantity":1,"unitPercentage":null,"amount":5897.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":5897.5,"unitQuantity":null,"unitPercentage":7.5,"amount":442.31,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3},{"from":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-12T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":5897.5,"unitQuantity":1,"unitPercentage":null,"amount":5897.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":5897.5,"unitQuantity":null,"unitPercentage":7.5,"amount":442.31,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KSFO","destination":"KLAX","departing":"2021-11-10T08:00:00.000Z","departingLocal":"2021-11-10T00:00:00.000Z","arrivingLocal":"2021-11-10T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KLAX","destination":"KSFO","departing":"2021-11-12T08:00:00.000Z","departingLocal":"2021-11-12T00:00:00.000Z","arrivingLocal":"2021-11-12T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":11874.99,"nonMemberPrice":11874.99,"original_price":11874.99,"sFtime":"0:06","origRequest":{"legFwd":420506,"legIDs":[420506,420507],"legRet":420507}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KSFO.KLAX.21.11.10.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '1688f858-5cde-4995-a4cf-45d68fabac38',
        requestId: 12772723,
        invoiceState: null,
        searchParams:
          '{"seg":["KSFO.KLAX.21.11.10.00.00","KLAX.KSFO.21.11.12.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: '0f2b0235-bd5a-4e80-ae72-f390be4c55e6',
        requestUrl: 'https://console.vista.studio/#fl:12772723',
        requestTime: '2021-10-27T18:31:16.744939+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 5,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2021-11-12T08:00:00+00:00',
      clientId: 1705839,
      requestId: 12772726,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:420563',
      flightRequestUrl: 'https://console.vista.studio/#fl:12772747',
      requestUrl: 'https://console.vista.studio/#l:12772783',
      flightRequestId: 12772747,
      legId: 420563,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12772747,
        clientId: 1705839,
        amount: 250,
        legId: 420563,
        legRequestId: 12772783,
      },
      flightRequest: {
        status: 101,
        updateTime: '2021-10-28T17:07:33.400803+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 12765.62,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/25406',
            createTime: '2021-10-28T04:02:17.752680+00:00',
            formUrlKey: '91ade0e5-2f71-4940-a87a-f91a98bb3273',
            clientSource: '2',
            formTplId: 359,
            id: 592406,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?91ade0e5-2f71-4940-a87a-f91a98bb3273',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?91ade0e5-2f71-4940-a87a-f91a98bb3273',
          },
        ],
        orderItemTotal: 12765.62,
        invoiceData: null,
        departureDate: '2021-11-10T00:00:00',
        assignedOperator: 2040155,
        total: '12765.62',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"Falcon 2000","tailNumber":"N234FJ","pax":2,"yom":1996,"safety_rating":{"argusSafety":"Platinum","wyvernSafety":"Wingman"},"price":11874.99,"taxes":{"fetTax":890.6246511627908},"amount":null,"src":null,"operator":{"id":"4a922f6c-92c2-4137-8e62-b4e4e0efaabd","name":"MAINE AVIATION AIRCRAFT CHARTER LLC"},"reqLegData":[{"from":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-10T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":5897.5,"unitQuantity":1,"unitPercentage":null,"amount":5897.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":5897.5,"unitQuantity":null,"unitPercentage":7.5,"amount":442.31,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3},{"from":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-12T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":5897.5,"unitQuantity":1,"unitPercentage":null,"amount":5897.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":5897.5,"unitQuantity":null,"unitPercentage":7.5,"amount":442.31,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KSFO","destination":"KLAX","departing":"2021-11-10T08:00:00.000Z","departingLocal":"2021-11-10T00:00:00.000Z","arrivingLocal":"2021-11-10T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KLAX","destination":"KSFO","departing":"2021-11-12T08:00:00.000Z","departingLocal":"2021-11-12T00:00:00.000Z","arrivingLocal":"2021-11-12T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":11874.99,"nonMemberPrice":11874.99,"original_price":11874.99,"sFtime":"0:06","origRequest":{"legFwd":420563,"legIDs":[420563,420564],"legRet":420564}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KSFO.KLAX.21.11.10.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '5a5502ef-008a-48b5-a7ee-69a3aa5b747b',
        requestId: 12772747,
        invoiceState: null,
        searchParams:
          '{"seg":["KSFO.KLAX.21.11.10.00.00","KLAX.KSFO.21.11.12.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: '0f2b0235-bd5a-4e80-ae72-f390be4c55e6',
        requestUrl: 'https://console.vista.studio/#fl:12772747',
        requestTime: '2021-10-28T04:02:12.828360+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 5,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2021-11-10T08:00:00+00:00',
      clientId: 1705839,
      requestId: 12772783,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:420564',
      flightRequestUrl: 'https://console.vista.studio/#fl:12772747',
      requestUrl: 'https://console.vista.studio/#l:12772784',
      flightRequestId: 12772747,
      legId: 420564,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12772747,
        clientId: 1705839,
        amount: 250,
        legId: 420564,
        legRequestId: 12772784,
      },
      flightRequest: {
        status: 101,
        updateTime: '2021-10-28T17:07:33.400803+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 12765.62,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/25406',
            createTime: '2021-10-28T04:02:17.752680+00:00',
            formUrlKey: '91ade0e5-2f71-4940-a87a-f91a98bb3273',
            clientSource: '2',
            formTplId: 359,
            id: 592406,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?91ade0e5-2f71-4940-a87a-f91a98bb3273',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?91ade0e5-2f71-4940-a87a-f91a98bb3273',
          },
        ],
        orderItemTotal: 12765.62,
        invoiceData: null,
        departureDate: '2021-11-10T00:00:00',
        assignedOperator: 2040155,
        total: '12765.62',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"Falcon 2000","tailNumber":"N234FJ","pax":2,"yom":1996,"safety_rating":{"argusSafety":"Platinum","wyvernSafety":"Wingman"},"price":11874.99,"taxes":{"fetTax":890.6246511627908},"amount":null,"src":null,"operator":{"id":"4a922f6c-92c2-4137-8e62-b4e4e0efaabd","name":"MAINE AVIATION AIRCRAFT CHARTER LLC"},"reqLegData":[{"from":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-10T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":5897.5,"unitQuantity":1,"unitPercentage":null,"amount":5897.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":5897.5,"unitQuantity":null,"unitPercentage":7.5,"amount":442.31,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3},{"from":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-12T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":5897.5,"unitQuantity":1,"unitPercentage":null,"amount":5897.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":5897.5,"unitQuantity":null,"unitPercentage":7.5,"amount":442.31,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KSFO","destination":"KLAX","departing":"2021-11-10T08:00:00.000Z","departingLocal":"2021-11-10T00:00:00.000Z","arrivingLocal":"2021-11-10T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KLAX","destination":"KSFO","departing":"2021-11-12T08:00:00.000Z","departingLocal":"2021-11-12T00:00:00.000Z","arrivingLocal":"2021-11-12T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":11874.99,"nonMemberPrice":11874.99,"original_price":11874.99,"sFtime":"0:06","origRequest":{"legFwd":420563,"legIDs":[420563,420564],"legRet":420564}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KSFO.KLAX.21.11.10.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '5a5502ef-008a-48b5-a7ee-69a3aa5b747b',
        requestId: 12772747,
        invoiceState: null,
        searchParams:
          '{"seg":["KSFO.KLAX.21.11.10.00.00","KLAX.KSFO.21.11.12.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: '0f2b0235-bd5a-4e80-ae72-f390be4c55e6',
        requestUrl: 'https://console.vista.studio/#fl:12772747',
        requestTime: '2021-10-28T04:02:12.828360+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 5,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2021-11-12T08:00:00+00:00',
      clientId: 1705839,
      requestId: 12772784,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:420565',
      flightRequestUrl: 'https://console.vista.studio/#fl:12772746',
      requestUrl: 'https://console.vista.studio/#l:12772785',
      flightRequestId: 12772746,
      legId: 420565,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12772746,
        clientId: 1705839,
        amount: 250,
        legId: 420565,
        legRequestId: 12772785,
      },
      flightRequest: {
        status: 101,
        updateTime: '2021-10-28T17:08:28.787166+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 12765.62,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/25405',
            createTime: '2021-10-28T04:01:53.566083+00:00',
            formUrlKey: 'f588cfb5-cd48-4907-ba42-76a11fc8affe',
            clientSource: '2',
            formTplId: 359,
            id: 592404,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?f588cfb5-cd48-4907-ba42-76a11fc8affe',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?f588cfb5-cd48-4907-ba42-76a11fc8affe',
          },
        ],
        orderItemTotal: 12765.62,
        invoiceData: null,
        departureDate: '2021-11-10T00:00:00',
        assignedOperator: 2040155,
        total: '12765.62',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"Falcon 2000","tailNumber":"N234FJ","pax":2,"yom":1996,"safety_rating":{"argusSafety":"Platinum","wyvernSafety":"Wingman"},"price":11874.99,"taxes":{"fetTax":890.6246511627908},"amount":null,"src":null,"operator":{"id":"4a922f6c-92c2-4137-8e62-b4e4e0efaabd","name":"MAINE AVIATION AIRCRAFT CHARTER LLC"},"reqLegData":[{"from":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-10T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":5897.5,"unitQuantity":1,"unitPercentage":null,"amount":5897.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":5897.5,"unitQuantity":null,"unitPercentage":7.5,"amount":442.31,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3},{"from":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-12T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":5897.5,"unitQuantity":1,"unitPercentage":null,"amount":5897.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":5897.5,"unitQuantity":null,"unitPercentage":7.5,"amount":442.31,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KSFO","destination":"KLAX","departing":"2021-11-10T08:00:00.000Z","departingLocal":"2021-11-10T00:00:00.000Z","arrivingLocal":"2021-11-10T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KLAX","destination":"KSFO","departing":"2021-11-12T08:00:00.000Z","departingLocal":"2021-11-12T00:00:00.000Z","arrivingLocal":"2021-11-12T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":11874.99,"nonMemberPrice":11874.99,"original_price":11874.99,"sFtime":"0:06","origRequest":{"legFwd":420565,"legIDs":[420565,420566],"legRet":420566}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KSFO.KLAX.21.11.10.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '3f97cdae-d35b-4f25-804a-fbc7d75398bb',
        requestId: 12772746,
        invoiceState: null,
        searchParams:
          '{"seg":["KSFO.KLAX.21.11.10.00.00","KLAX.KSFO.21.11.12.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: '0f2b0235-bd5a-4e80-ae72-f390be4c55e6',
        requestUrl: 'https://console.vista.studio/#fl:12772746',
        requestTime: '2021-10-28T04:01:48.277396+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 5,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2021-11-10T08:00:00+00:00',
      clientId: 1705839,
      requestId: 12772785,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:420566',
      flightRequestUrl: 'https://console.vista.studio/#fl:12772746',
      requestUrl: 'https://console.vista.studio/#l:12772786',
      flightRequestId: 12772746,
      legId: 420566,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12772746,
        clientId: 1705839,
        amount: 250,
        legId: 420566,
        legRequestId: 12772786,
      },
      flightRequest: {
        status: 101,
        updateTime: '2021-10-28T17:08:28.787166+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 12765.62,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/25405',
            createTime: '2021-10-28T04:01:53.566083+00:00',
            formUrlKey: 'f588cfb5-cd48-4907-ba42-76a11fc8affe',
            clientSource: '2',
            formTplId: 359,
            id: 592404,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?f588cfb5-cd48-4907-ba42-76a11fc8affe',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?f588cfb5-cd48-4907-ba42-76a11fc8affe',
          },
        ],
        orderItemTotal: 12765.62,
        invoiceData: null,
        departureDate: '2021-11-10T00:00:00',
        assignedOperator: 2040155,
        total: '12765.62',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"Falcon 2000","tailNumber":"N234FJ","pax":2,"yom":1996,"safety_rating":{"argusSafety":"Platinum","wyvernSafety":"Wingman"},"price":11874.99,"taxes":{"fetTax":890.6246511627908},"amount":null,"src":null,"operator":{"id":"4a922f6c-92c2-4137-8e62-b4e4e0efaabd","name":"MAINE AVIATION AIRCRAFT CHARTER LLC"},"reqLegData":[{"from":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-10T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":5897.5,"unitQuantity":1,"unitPercentage":null,"amount":5897.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":5897.5,"unitQuantity":null,"unitPercentage":7.5,"amount":442.31,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3},{"from":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-12T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":5897.5,"unitQuantity":1,"unitPercentage":null,"amount":5897.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":5897.5,"unitQuantity":null,"unitPercentage":7.5,"amount":442.31,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KSFO","destination":"KLAX","departing":"2021-11-10T08:00:00.000Z","departingLocal":"2021-11-10T00:00:00.000Z","arrivingLocal":"2021-11-10T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KLAX","destination":"KSFO","departing":"2021-11-12T08:00:00.000Z","departingLocal":"2021-11-12T00:00:00.000Z","arrivingLocal":"2021-11-12T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":11874.99,"nonMemberPrice":11874.99,"original_price":11874.99,"sFtime":"0:06","origRequest":{"legFwd":420565,"legIDs":[420565,420566],"legRet":420566}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KSFO.KLAX.21.11.10.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '3f97cdae-d35b-4f25-804a-fbc7d75398bb',
        requestId: 12772746,
        invoiceState: null,
        searchParams:
          '{"seg":["KSFO.KLAX.21.11.10.00.00","KLAX.KSFO.21.11.12.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: '0f2b0235-bd5a-4e80-ae72-f390be4c55e6',
        requestUrl: 'https://console.vista.studio/#fl:12772746',
        requestTime: '2021-10-28T04:01:48.277396+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 5,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2021-11-12T08:00:00+00:00',
      clientId: 1705839,
      requestId: 12772786,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:420567',
      flightRequestUrl: 'https://console.vista.studio/#fl:12772724',
      requestUrl: 'https://console.vista.studio/#l:12772787',
      flightRequestId: 12772724,
      legId: 420567,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12772724,
        clientId: 1705839,
        amount: 250,
        legId: 420567,
        legRequestId: 12772787,
      },
      flightRequest: {
        status: 101,
        updateTime: '2021-10-28T17:12:25.905890+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 13303.12,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/25403',
            createTime: '2021-10-27T18:31:52.630093+00:00',
            formUrlKey: '770be65e-6254-4a89-b7e4-5c0457b1adfd',
            clientSource: '2',
            formTplId: 359,
            id: 592391,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?770be65e-6254-4a89-b7e4-5c0457b1adfd',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?770be65e-6254-4a89-b7e4-5c0457b1adfd',
          },
        ],
        orderItemTotal: 13303.12,
        invoiceData: null,
        departureDate: '2021-11-10T00:00:00',
        assignedOperator: 2040155,
        total: '13303.12',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"Falcon 2000","tailNumber":"N234FJ","pax":2,"yom":1996,"safety_rating":{"argusSafety":"Platinum","wyvernSafety":"Wingman"},"price":12374.99,"taxes":{"fetTax":928.1246511627908},"amount":null,"src":null,"operator":{"id":"4a922f6c-92c2-4137-8e62-b4e4e0efaabd","name":"MAINE AVIATION AIRCRAFT CHARTER LLC"},"reqLegData":[{"from":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-10T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":6147.5,"unitQuantity":1,"unitPercentage":null,"amount":6147.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":6147.5,"unitQuantity":null,"unitPercentage":7.5,"amount":461.06,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3},{"from":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-12T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":6147.5,"unitQuantity":1,"unitPercentage":null,"amount":6147.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":6147.5,"unitQuantity":null,"unitPercentage":7.5,"amount":461.06,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KSFO","destination":"KLAX","departing":"2021-11-10T08:00:00.000Z","departingLocal":"2021-11-10T00:00:00.000Z","arrivingLocal":"2021-11-10T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KLAX","destination":"KSFO","departing":"2021-11-12T08:00:00.000Z","departingLocal":"2021-11-12T00:00:00.000Z","arrivingLocal":"2021-11-12T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":12374.99,"nonMemberPrice":12374.99,"original_price":12374.99,"sFtime":"0:06","origRequest":{"legFwd":420567,"legIDs":[420567,420568],"legRet":420568}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KSFO.KLAX.21.11.10.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '92b7378e-1d40-483f-9d5c-cbb1bdd295dd',
        requestId: 12772724,
        invoiceState: null,
        searchParams:
          '{"seg":["KSFO.KLAX.21.11.10.00.00","KLAX.KSFO.21.11.12.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: '0f2b0235-bd5a-4e80-ae72-f390be4c55e6',
        requestUrl: 'https://console.vista.studio/#fl:12772724',
        requestTime: '2021-10-27T18:31:45.176172+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 5,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2021-11-10T08:00:00+00:00',
      clientId: 1705839,
      requestId: 12772787,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:420568',
      flightRequestUrl: 'https://console.vista.studio/#fl:12772724',
      requestUrl: 'https://console.vista.studio/#l:12772788',
      flightRequestId: 12772724,
      legId: 420568,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12772724,
        clientId: 1705839,
        amount: 250,
        legId: 420568,
        legRequestId: 12772788,
      },
      flightRequest: {
        status: 101,
        updateTime: '2021-10-28T17:12:25.905890+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 13303.12,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/25403',
            createTime: '2021-10-27T18:31:52.630093+00:00',
            formUrlKey: '770be65e-6254-4a89-b7e4-5c0457b1adfd',
            clientSource: '2',
            formTplId: 359,
            id: 592391,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?770be65e-6254-4a89-b7e4-5c0457b1adfd',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?770be65e-6254-4a89-b7e4-5c0457b1adfd',
          },
        ],
        orderItemTotal: 13303.12,
        invoiceData: null,
        departureDate: '2021-11-10T00:00:00',
        assignedOperator: 2040155,
        total: '13303.12',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"Falcon 2000","tailNumber":"N234FJ","pax":2,"yom":1996,"safety_rating":{"argusSafety":"Platinum","wyvernSafety":"Wingman"},"price":12374.99,"taxes":{"fetTax":928.1246511627908},"amount":null,"src":null,"operator":{"id":"4a922f6c-92c2-4137-8e62-b4e4e0efaabd","name":"MAINE AVIATION AIRCRAFT CHARTER LLC"},"reqLegData":[{"from":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-10T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":6147.5,"unitQuantity":1,"unitPercentage":null,"amount":6147.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":6147.5,"unitQuantity":null,"unitPercentage":7.5,"amount":461.06,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3},{"from":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-12T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":6147.5,"unitQuantity":1,"unitPercentage":null,"amount":6147.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":6147.5,"unitQuantity":null,"unitPercentage":7.5,"amount":461.06,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KSFO","destination":"KLAX","departing":"2021-11-10T08:00:00.000Z","departingLocal":"2021-11-10T00:00:00.000Z","arrivingLocal":"2021-11-10T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KLAX","destination":"KSFO","departing":"2021-11-12T08:00:00.000Z","departingLocal":"2021-11-12T00:00:00.000Z","arrivingLocal":"2021-11-12T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":12374.99,"nonMemberPrice":12374.99,"original_price":12374.99,"sFtime":"0:06","origRequest":{"legFwd":420567,"legIDs":[420567,420568],"legRet":420568}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KSFO.KLAX.21.11.10.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '92b7378e-1d40-483f-9d5c-cbb1bdd295dd',
        requestId: 12772724,
        invoiceState: null,
        searchParams:
          '{"seg":["KSFO.KLAX.21.11.10.00.00","KLAX.KSFO.21.11.12.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: '0f2b0235-bd5a-4e80-ae72-f390be4c55e6',
        requestUrl: 'https://console.vista.studio/#fl:12772724',
        requestTime: '2021-10-27T18:31:45.176172+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 5,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2021-11-12T08:00:00+00:00',
      clientId: 1705839,
      requestId: 12772788,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:420747',
      flightRequestUrl: 'https://console.vista.studio/#fl:12772329',
      requestUrl: 'https://console.vista.studio/#l:12772920',
      flightRequestId: 12772329,
      legId: 420747,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12772329,
        clientId: 1705839,
        amount: 250,
        legId: 420747,
        legRequestId: 12772920,
      },
      flightRequest: {
        status: 101,
        updateTime: '2021-10-30T21:08:28.084990+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 13088.12,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/25357',
            createTime: '2021-10-21T04:31:48.619127+00:00',
            formUrlKey: '1a3aa657-a9f4-43c8-b37c-43d7408f6724',
            clientSource: '2',
            formTplId: 359,
            id: 592261,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?1a3aa657-a9f4-43c8-b37c-43d7408f6724',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?1a3aa657-a9f4-43c8-b37c-43d7408f6724',
          },
        ],
        orderItemTotal: 13088.12,
        invoiceData: null,
        departureDate: '2021-11-10T00:00:00',
        assignedOperator: 2040155,
        total: '13088.12',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"Falcon 2000","tailNumber":"N234FJ","pax":2,"yom":1996,"safety_rating":{"argusSafety":"Platinum","wyvernSafety":"Wingman"},"price":12174.99,"taxes":{"fetTax":913.1246511627908},"amount":null,"src":null,"operator":{"id":"4a922f6c-92c2-4137-8e62-b4e4e0efaabd","name":"MAINE AVIATION AIRCRAFT CHARTER LLC"},"reqLegData":[{"from":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-10T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":6047.5,"unitQuantity":1,"unitPercentage":null,"amount":6047.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":6047.5,"unitQuantity":null,"unitPercentage":7.5,"amount":453.56,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3},{"from":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-12T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":6047.5,"unitQuantity":1,"unitPercentage":null,"amount":6047.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":6047.5,"unitQuantity":null,"unitPercentage":7.5,"amount":453.56,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KSFO","destination":"KLAX","departing":"2021-11-10T08:00:00.000Z","departingLocal":"2021-11-10T00:00:00.000Z","arrivingLocal":"2021-11-10T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KLAX","destination":"KSFO","departing":"2021-11-12T08:00:00.000Z","departingLocal":"2021-11-12T00:00:00.000Z","arrivingLocal":"2021-11-12T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":12174.99,"nonMemberPrice":12174.99,"original_price":12174.99,"sFtime":"0:06","origRequest":{"legFwd":420747,"legIDs":[420747,420748],"legRet":420748}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KSFO.KLAX.21.11.10.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '519b223d-8021-4660-aa85-411b79718442',
        requestId: 12772329,
        invoiceState: null,
        searchParams:
          '{"seg":["KSFO.KLAX.21.11.10.00.00","KLAX.KSFO.21.11.12.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: '0f2b0235-bd5a-4e80-ae72-f390be4c55e6',
        requestUrl: 'https://console.vista.studio/#fl:12772329',
        requestTime: '2021-10-21T04:31:44.894111+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 5,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2021-11-10T08:00:00+00:00',
      clientId: 1705839,
      requestId: 12772920,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:420748',
      flightRequestUrl: 'https://console.vista.studio/#fl:12772329',
      requestUrl: 'https://console.vista.studio/#l:12772921',
      flightRequestId: 12772329,
      legId: 420748,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12772329,
        clientId: 1705839,
        amount: 250,
        legId: 420748,
        legRequestId: 12772921,
      },
      flightRequest: {
        status: 101,
        updateTime: '2021-10-30T21:08:28.084990+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 13088.12,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/25357',
            createTime: '2021-10-21T04:31:48.619127+00:00',
            formUrlKey: '1a3aa657-a9f4-43c8-b37c-43d7408f6724',
            clientSource: '2',
            formTplId: 359,
            id: 592261,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?1a3aa657-a9f4-43c8-b37c-43d7408f6724',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?1a3aa657-a9f4-43c8-b37c-43d7408f6724',
          },
        ],
        orderItemTotal: 13088.12,
        invoiceData: null,
        departureDate: '2021-11-10T00:00:00',
        assignedOperator: 2040155,
        total: '13088.12',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"Falcon 2000","tailNumber":"N234FJ","pax":2,"yom":1996,"safety_rating":{"argusSafety":"Platinum","wyvernSafety":"Wingman"},"price":12174.99,"taxes":{"fetTax":913.1246511627908},"amount":null,"src":null,"operator":{"id":"4a922f6c-92c2-4137-8e62-b4e4e0efaabd","name":"MAINE AVIATION AIRCRAFT CHARTER LLC"},"reqLegData":[{"from":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-10T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":6047.5,"unitQuantity":1,"unitPercentage":null,"amount":6047.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":6047.5,"unitQuantity":null,"unitPercentage":7.5,"amount":453.56,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3},{"from":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-12T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":6047.5,"unitQuantity":1,"unitPercentage":null,"amount":6047.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":6047.5,"unitQuantity":null,"unitPercentage":7.5,"amount":453.56,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KSFO","destination":"KLAX","departing":"2021-11-10T08:00:00.000Z","departingLocal":"2021-11-10T00:00:00.000Z","arrivingLocal":"2021-11-10T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KLAX","destination":"KSFO","departing":"2021-11-12T08:00:00.000Z","departingLocal":"2021-11-12T00:00:00.000Z","arrivingLocal":"2021-11-12T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":12174.99,"nonMemberPrice":12174.99,"original_price":12174.99,"sFtime":"0:06","origRequest":{"legFwd":420747,"legIDs":[420747,420748],"legRet":420748}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KSFO.KLAX.21.11.10.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '519b223d-8021-4660-aa85-411b79718442',
        requestId: 12772329,
        invoiceState: null,
        searchParams:
          '{"seg":["KSFO.KLAX.21.11.10.00.00","KLAX.KSFO.21.11.12.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: '0f2b0235-bd5a-4e80-ae72-f390be4c55e6',
        requestUrl: 'https://console.vista.studio/#fl:12772329',
        requestTime: '2021-10-21T04:31:44.894111+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 5,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2021-11-12T08:00:00+00:00',
      clientId: 1705839,
      requestId: 12772921,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:420749',
      flightRequestUrl: 'https://console.vista.studio/#fl:12772922',
      requestUrl: 'https://console.vista.studio/#l:12772923',
      flightRequestId: 12772922,
      legId: 420749,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12772922,
        clientId: 1705839,
        amount: 250,
        legId: 420749,
        legRequestId: 12772923,
      },
      flightRequest: {
        status: 101,
        updateTime: '2021-10-30T21:18:51.395338+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 12765.62,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/25458',
            createTime: '2021-10-30T21:15:58.677226+00:00',
            formUrlKey: '820eb23f-718a-494e-9462-29328e0c2458',
            clientSource: '2',
            formTplId: 359,
            id: 592465,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?820eb23f-718a-494e-9462-29328e0c2458',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?820eb23f-718a-494e-9462-29328e0c2458',
          },
        ],
        orderItemTotal: 12765.62,
        invoiceData: null,
        departureDate: '2021-11-10T00:00:00',
        assignedOperator: 2040155,
        total: '12765.62',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"Falcon 2000","tailNumber":"N234FJ","pax":2,"yom":1996,"safety_rating":{"argusSafety":"Platinum","wyvernSafety":"Wingman"},"price":11874.99,"taxes":{"fetTax":890.6246511627908},"amount":null,"src":null,"operator":{"id":"4a922f6c-92c2-4137-8e62-b4e4e0efaabd","name":"MAINE AVIATION AIRCRAFT CHARTER LLC"},"reqLegData":[{"from":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-10T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":5897.5,"unitQuantity":1,"unitPercentage":null,"amount":5897.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":5897.5,"unitQuantity":null,"unitPercentage":7.5,"amount":442.31,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3},{"from":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-12T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":5897.5,"unitQuantity":1,"unitPercentage":null,"amount":5897.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":5897.5,"unitQuantity":null,"unitPercentage":7.5,"amount":442.31,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KSFO","destination":"KLAX","departing":"2021-11-10T08:00:00.000Z","departingLocal":"2021-11-10T00:00:00.000Z","arrivingLocal":"2021-11-10T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KLAX","destination":"KSFO","departing":"2021-11-12T08:00:00.000Z","departingLocal":"2021-11-12T00:00:00.000Z","arrivingLocal":"2021-11-12T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":11874.99,"nonMemberPrice":11874.99,"original_price":11874.99,"sFtime":"0:06","origRequest":{"legFwd":420749,"legIDs":[420749,420750],"legRet":420750}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KSFO.KLAX.21.11.10.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: 'c70557e6-84c0-444e-a5da-8bf8fa265509',
        requestId: 12772922,
        invoiceState: null,
        searchParams:
          '{"seg":["KSFO.KLAX.21.11.10.00.00","KLAX.KSFO.21.11.12.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: '0f2b0235-bd5a-4e80-ae72-f390be4c55e6',
        requestUrl: 'https://console.vista.studio/#fl:12772922',
        requestTime: '2021-10-30T21:15:46.952776+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 5,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2021-11-10T08:00:00+00:00',
      clientId: 1705839,
      requestId: 12772923,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:420750',
      flightRequestUrl: 'https://console.vista.studio/#fl:12772922',
      requestUrl: 'https://console.vista.studio/#l:12772924',
      flightRequestId: 12772922,
      legId: 420750,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12772922,
        clientId: 1705839,
        amount: 250,
        legId: 420750,
        legRequestId: 12772924,
      },
      flightRequest: {
        status: 101,
        updateTime: '2021-10-30T21:18:51.395338+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 12765.62,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/25458',
            createTime: '2021-10-30T21:15:58.677226+00:00',
            formUrlKey: '820eb23f-718a-494e-9462-29328e0c2458',
            clientSource: '2',
            formTplId: 359,
            id: 592465,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?820eb23f-718a-494e-9462-29328e0c2458',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?820eb23f-718a-494e-9462-29328e0c2458',
          },
        ],
        orderItemTotal: 12765.62,
        invoiceData: null,
        departureDate: '2021-11-10T00:00:00',
        assignedOperator: 2040155,
        total: '12765.62',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"Falcon 2000","tailNumber":"N234FJ","pax":2,"yom":1996,"safety_rating":{"argusSafety":"Platinum","wyvernSafety":"Wingman"},"price":11874.99,"taxes":{"fetTax":890.6246511627908},"amount":null,"src":null,"operator":{"id":"4a922f6c-92c2-4137-8e62-b4e4e0efaabd","name":"MAINE AVIATION AIRCRAFT CHARTER LLC"},"reqLegData":[{"from":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-10T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":5897.5,"unitQuantity":1,"unitPercentage":null,"amount":5897.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":5897.5,"unitQuantity":null,"unitPercentage":7.5,"amount":442.31,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3},{"from":{"city":"Los Angeles","country":"United States","iata":"LAX","icao":"KLAX","lon":-118.4080683,"lat":33.9424953,"name":"Los Angeles Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"to":{"city":"San Francisco","country":"United States","iata":"SFO","icao":"KSFO","lon":-122.3748889,"lat":37.6189722,"name":"San Francisco Intl","tz":-25200000,"tzn":"America/Los_Angeles"},"date":"2021-11-12T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":5897.5,"unitQuantity":1,"unitPercentage":null,"amount":5897.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":5897.5,"unitQuantity":null,"unitPercentage":7.5,"amount":442.31,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KSFO","destination":"KLAX","departing":"2021-11-10T08:00:00.000Z","departingLocal":"2021-11-10T00:00:00.000Z","arrivingLocal":"2021-11-10T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KLAX","destination":"KSFO","departing":"2021-11-12T08:00:00.000Z","departingLocal":"2021-11-12T00:00:00.000Z","arrivingLocal":"2021-11-12T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":11874.99,"nonMemberPrice":11874.99,"original_price":11874.99,"sFtime":"0:06","origRequest":{"legFwd":420749,"legIDs":[420749,420750],"legRet":420750}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KSFO.KLAX.21.11.10.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: 'c70557e6-84c0-444e-a5da-8bf8fa265509',
        requestId: 12772922,
        invoiceState: null,
        searchParams:
          '{"seg":["KSFO.KLAX.21.11.10.00.00","KLAX.KSFO.21.11.12.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: '0f2b0235-bd5a-4e80-ae72-f390be4c55e6',
        requestUrl: 'https://console.vista.studio/#fl:12772922',
        requestTime: '2021-10-30T21:15:46.952776+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 5,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2021-11-12T08:00:00+00:00',
      clientId: 1705839,
      requestId: 12772924,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:424446',
      flightRequestUrl: 'https://console.vista.studio/#fl:12778547',
      requestUrl: 'https://console.vista.studio/#l:12778548',
      flightRequestId: 12778547,
      legId: 424446,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12778547,
        clientId: 1705839,
        amount: 250,
        legId: 424446,
        legRequestId: 12778548,
      },
      flightRequest: {
        status: 101,
        updateTime: '2021-12-30T23:34:05.379379+00:00',
        processorReply: null,
        achData: null,
        invoices: [],
        orderItemTotal: 0,
        invoiceData: null,
        departureDate: '2022-01-10T00:00:00',
        assignedOperator: 2040155,
        total: '0',
        requestText:
          '{"ftime":3,"ftime_seg_max":3,"img":[],"title":"Falcon 2000","tailNumber":"N234FJ","pax":2,"yom":1996,"safety_rating":{"argusSafety":"Platinum","wyvernSafety":"Wingman"},"price":0,"taxes":{"fetTax":0},"amount":null,"src":null,"operator":{"id":"4a922f6c-92c2-4137-8e62-b4e4e0efaabd","name":"MAINE AVIATION AIRCRAFT CHARTER LLC"},"reqLegData":[{"from":{"city":"Ft Lauderdale","country":"United States","iata":"FLL","icao":"KFLL","lon":-80.1527414,"lat":26.0725961,"name":"Hollywood Intl","tz":-14400000,"tzn":"America/New_York"},"to":{"city":"Teterboro","country":"United States","iata":"TEB","icao":"KTEB","lon":-74.0608361,"lat":40.8501014,"name":"Teterboro","tz":-14400000,"tzn":"America/New_York"},"date":"2022-01-10T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":0,"unitQuantity":1,"unitPercentage":null,"amount":0,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KFLL","destination":"KTEB","departing":"2022-01-10T05:00:00.000Z","departingLocal":"2022-01-10T00:00:00.000Z","arrivingLocal":"2022-01-10T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":0,"nonMemberPrice":0,"original_price":0,"sFtime":"0:03","origRequest":{"legFwd":424446,"legIDs":[424446]}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KFLL.KTEB.22.01.10.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '08fe4f42-a19e-416b-acc3-697024cb57c0',
        requestId: 12778547,
        invoiceState: null,
        searchParams:
          '{"seg":["KFLL.KTEB.22.01.10.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: 'cd6fcacd-91b0-473d-84a2-f6912d141841',
        requestUrl: 'https://console.vista.studio/#fl:12778547',
        requestTime: '2021-12-30T23:28:06.046318+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 1,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2022-01-10T05:00:00+00:00',
      clientId: 1705839,
      requestId: 12778548,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:424447',
      flightRequestUrl: 'https://console.vista.studio/#fl:12778549',
      requestUrl: 'https://console.vista.studio/#l:12778550',
      flightRequestId: 12778549,
      legId: 424447,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12778549,
        clientId: 1705839,
        amount: 250,
        legId: 424447,
        legRequestId: 12778550,
      },
      flightRequest: {
        status: 101,
        updateTime: '2021-12-30T23:53:04.785066+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 0,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/26550',
            createTime: '2021-12-30T23:47:20.859769+00:00',
            formUrlKey: 'd390313a-fef4-4d4f-b688-0a86c3ecbd67',
            clientSource: '2',
            formTplId: 359,
            id: 594835,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?d390313a-fef4-4d4f-b688-0a86c3ecbd67',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?d390313a-fef4-4d4f-b688-0a86c3ecbd67',
          },
          {
            totalPrice: 0,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/26551',
            createTime: '2021-12-31T00:08:59.089777+00:00',
            formUrlKey: '3c65bacc-89eb-40e7-8951-8484aa430cd7',
            clientSource: '2',
            formTplId: 362,
            id: 594837,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?3c65bacc-89eb-40e7-8951-8484aa430cd7',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/?3c65bacc-89eb-40e7-8951-8484aa430cd7',
          },
          {
            totalPrice: 0,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/26552',
            createTime: '2021-12-31T00:14:16.877673+00:00',
            formUrlKey: 'd6aaab36-270d-4539-b715-a848ee1d4c78',
            clientSource: '2',
            formTplId: 360,
            id: 594839,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add/edit/?d6aaab36-270d-4539-b715-a848ee1d4c78',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add/?d6aaab36-270d-4539-b715-a848ee1d4c78',
          },
          {
            totalPrice: 25410,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/26553',
            createTime: '2021-12-31T00:21:44.598204+00:00',
            formUrlKey: '8938258a-a2e9-459e-99f3-7c1d343e4f14',
            clientSource: '2',
            formTplId: 362,
            id: 594842,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?8938258a-a2e9-459e-99f3-7c1d343e4f14',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/?8938258a-a2e9-459e-99f3-7c1d343e4f14',
          },
        ],
        orderItemTotal: 25410,
        invoiceData: null,
        departureDate: '2022-01-10T00:00:00',
        assignedOperator: 2040155,
        total: '23295',
        requestText:
          '{"ftime":3,"ftime_seg_max":3,"img":[],"title":"Falcon 2000","tailNumber":"N234FJ","pax":2,"yom":1996,"safety_rating":{"argusSafety":"Platinum","wyvernSafety":"Wingman"},"price":21669.76,"taxes":{"fetTax":1625.232558139535},"amount":null,"src":null,"operator":{"id":"4a922f6c-92c2-4137-8e62-b4e4e0efaabd","name":"MAINE AVIATION AIRCRAFT CHARTER LLC"},"reqLegData":[{"from":{"city":"Ft Lauderdale","country":"United States","iata":"FLL","icao":"KFLL","lon":-80.1527414,"lat":26.0725961,"name":"Hollywood Intl","tz":-14400000,"tzn":"America/New_York"},"to":{"city":"Teterboro","country":"United States","iata":"TEB","icao":"KTEB","lon":-74.0608361,"lat":40.8501014,"name":"Teterboro","tz":-14400000,"tzn":"America/New_York"},"date":"2022-01-10T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":23295,"unitQuantity":1,"unitPercentage":null,"amount":23295,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KFLL","destination":"KTEB","departing":"2022-01-10T05:00:00.000Z","departingLocal":"2022-01-10T00:00:00.000Z","arrivingLocal":"2022-01-10T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":21669.76,"nonMemberPrice":21669.76,"original_price":21669.76,"sFtime":"0:03","origRequest":{"legFwd":424447,"legIDs":[424447]}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KFLL.KTEB.22.01.10.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '227969bb-171d-4532-a891-690863982f9f',
        requestId: 12778549,
        invoiceState: null,
        searchParams:
          '{"seg":["KFLL.KTEB.22.01.10.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: 'cd6fcacd-91b0-473d-84a2-f6912d141841',
        requestUrl: 'https://console.vista.studio/#fl:12778549',
        requestTime: '2021-12-30T23:47:12.798065+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 9,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2022-01-10T05:00:00+00:00',
      clientId: 1705839,
      requestId: 12778550,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:424448',
      flightRequestUrl: 'https://console.vista.studio/#fl:12778551',
      requestUrl: 'https://console.vista.studio/#l:12778552',
      flightRequestId: 12778551,
      legId: 424448,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12778551,
        clientId: 1705839,
        amount: 250,
        legId: 424448,
        legRequestId: 12778552,
      },
      flightRequest: {
        status: 101,
        updateTime: '2021-12-31T00:35:31.363749+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 25085.13,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/26554',
            createTime: '2021-12-31T00:29:24.312054+00:00',
            formUrlKey: '786128c6-e7ca-4216-93fc-e7f32c9d867f',
            clientSource: '2',
            formTplId: 359,
            id: 594844,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?786128c6-e7ca-4216-93fc-e7f32c9d867f',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?786128c6-e7ca-4216-93fc-e7f32c9d867f',
          },
          {
            totalPrice: 21543,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/26555',
            createTime: '2021-12-31T00:34:42.908196+00:00',
            formUrlKey: '3411009a-21e4-41e8-8157-b59f001bc850',
            clientSource: '2',
            formTplId: 362,
            id: 594846,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?3411009a-21e4-41e8-8157-b59f001bc850',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/?3411009a-21e4-41e8-8157-b59f001bc850',
          },
          {
            totalPrice: 5375,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/26556',
            createTime: '2021-12-31T00:36:54.548863+00:00',
            formUrlKey: '081f4ad7-95f1-4c2f-8577-0fbf1e20c8ba',
            clientSource: '2',
            formTplId: 360,
            id: 594848,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add/edit/?081f4ad7-95f1-4c2f-8577-0fbf1e20c8ba',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add/?081f4ad7-95f1-4c2f-8577-0fbf1e20c8ba',
          },
          {
            totalPrice: 1075,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/26557',
            createTime: '2021-12-31T00:42:11.966612+00:00',
            formUrlKey: 'a7178993-e070-4aa3-8a76-fb71160bba21',
            clientSource: '2',
            formTplId: 360,
            id: 594850,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add/edit/?a7178993-e070-4aa3-8a76-fb71160bba21',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add/?a7178993-e070-4aa3-8a76-fb71160bba21',
          },
          {
            totalPrice: 1075,
            orderPaymentStatus: -1,
            createTime: '2022-01-05T20:17:26.597843+00:00',
            formUrlKey: 'feabc2a6-f7c8-4498-ab2c-7caab389eed0',
            clientSource: '2',
            formTplId: 361,
            id: 594889,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_mod/edit/?feabc2a6-f7c8-4498-ab2c-7caab389eed0',
            invoicePaymentStatus: 2,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_mod/?feabc2a6-f7c8-4498-ab2c-7caab389eed0',
          },
        ],
        orderItemTotal: 1075,
        invoiceData: null,
        departureDate: '2022-01-10T00:00:00',
        assignedOperator: 2040155,
        total: '25085.13',
        requestText:
          '{"ftime":3,"ftime_seg_max":3,"img":[],"title":"Falcon 2000","tailNumber":"N234FJ","pax":2,"yom":1996,"safety_rating":{"argusSafety":"Platinum","wyvernSafety":"Wingman"},"price":23335,"taxes":{"fetTax":1750.1253488372092},"amount":null,"src":null,"operator":{"id":"4a922f6c-92c2-4137-8e62-b4e4e0efaabd","name":"MAINE AVIATION AIRCRAFT CHARTER LLC"},"reqLegData":[{"from":{"city":"Ft Lauderdale","country":"United States","iata":"FLL","icao":"KFLL","lon":-80.1527414,"lat":26.0725961,"name":"Hollywood Intl","tz":-14400000,"tzn":"America/New_York"},"to":{"city":"Teterboro","country":"United States","iata":"TEB","icao":"KTEB","lon":-74.0608361,"lat":40.8501014,"name":"Teterboro","tz":-14400000,"tzn":"America/New_York"},"date":"2022-01-10T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":23295,"unitQuantity":1,"unitPercentage":null,"amount":23295,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":23295,"unitQuantity":null,"unitPercentage":7.5,"amount":1747.13,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.3,"unitPercentage":null},"unitBasePrice":4.3,"unitQuantity":10,"unitPercentage":null,"amount":43,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KFLL","destination":"KTEB","departing":"2022-01-10T05:00:00.000Z","departingLocal":"2022-01-10T00:00:00.000Z","arrivingLocal":"2022-01-10T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":23335,"nonMemberPrice":23335,"original_price":23335,"sFtime":"0:03","origRequest":{"legFwd":424448,"legIDs":[424448]}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KFLL.KTEB.22.01.10.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '1167aaa1-ec71-412f-af45-c91feb78858a',
        requestId: 12778551,
        invoiceState: null,
        searchParams:
          '{"seg":["KFLL.KTEB.22.01.10.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: 'cd6fcacd-91b0-473d-84a2-f6912d141841',
        requestUrl: 'https://console.vista.studio/#fl:12778551',
        requestTime: '2021-12-31T00:29:18.767667+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 6,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2022-01-10T05:00:00+00:00',
      clientId: 1705839,
      requestId: 12778552,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:424691',
      flightRequestUrl: 'https://console.vista.studio/#fl:12778635',
      requestUrl: 'https://console.vista.studio/#l:12778636',
      flightRequestId: 12778635,
      legId: 424691,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12778635,
        clientId: 1705839,
        amount: 250,
        legId: 424691,
        legRequestId: 12778636,
      },
      flightRequest: {
        status: 101,
        updateTime: '2022-01-05T18:40:30.127030+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 0,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/26561',
            createTime: '2022-01-05T18:39:15.332522+00:00',
            formUrlKey: '15135f70-5f06-46ea-a938-91bd07dbb224',
            clientSource: '2',
            formTplId: 359,
            id: 594875,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?15135f70-5f06-46ea-a938-91bd07dbb224',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?15135f70-5f06-46ea-a938-91bd07dbb224',
          },
          {
            totalPrice: 0,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/26562',
            createTime: '2022-01-05T18:47:16.991269+00:00',
            formUrlKey: '87f1cb77-7efd-41b1-af9c-7af7f922e439',
            clientSource: '2',
            formTplId: 362,
            id: 594877,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?87f1cb77-7efd-41b1-af9c-7af7f922e439',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/?87f1cb77-7efd-41b1-af9c-7af7f922e439',
          },
          {
            totalPrice: 0,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/26563',
            createTime: '2022-01-05T18:50:57.084096+00:00',
            formUrlKey: '7f95e6cb-d7e1-4149-a837-adffa81c4e56',
            clientSource: '2',
            formTplId: 360,
            id: 594879,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add/edit/?7f95e6cb-d7e1-4149-a837-adffa81c4e56',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add/?7f95e6cb-d7e1-4149-a837-adffa81c4e56',
          },
          {
            totalPrice: 11000,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/26564',
            createTime: '2022-01-05T18:56:28.391012+00:00',
            formUrlKey: '5f6fd29b-e7d2-4331-8a49-0d5c83785e0d',
            clientSource: '2',
            formTplId: 362,
            id: 594881,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?5f6fd29b-e7d2-4331-8a49-0d5c83785e0d',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/?5f6fd29b-e7d2-4331-8a49-0d5c83785e0d',
          },
        ],
        orderItemTotal: 11000,
        invoiceData: null,
        departureDate: '2022-01-10T00:00:00',
        assignedOperator: 2040155,
        total: '20000',
        requestText:
          '{"ftime":3,"ftime_seg_max":3,"img":[],"title":"Falcon 2000","tailNumber":"N234FJ","pax":2,"yom":1996,"safety_rating":{"argusSafety":"Platinum","wyvernSafety":"Wingman"},"price":18604.65,"taxes":{"fetTax":1395.3488372093022},"amount":null,"src":null,"operator":{"id":"4a922f6c-92c2-4137-8e62-b4e4e0efaabd","name":"MAINE AVIATION AIRCRAFT CHARTER LLC"},"reqLegData":[{"from":{"city":"Ft Lauderdale","country":"United States","iata":"FLL","icao":"KFLL","lon":-80.1527414,"lat":26.0725961,"name":"Hollywood Intl","tz":-14400000,"tzn":"America/New_York"},"to":{"city":"Teterboro","country":"United States","iata":"TEB","icao":"KTEB","lon":-74.0608361,"lat":40.8501014,"name":"Teterboro","tz":-14400000,"tzn":"America/New_York"},"date":"2022-01-10T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":20000,"unitQuantity":1,"unitPercentage":null,"amount":20000,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KFLL","destination":"KTEB","departing":"2022-01-10T05:00:00.000Z","departingLocal":"2022-01-10T00:00:00.000Z","arrivingLocal":"2022-01-10T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":18604.65,"nonMemberPrice":18604.65,"original_price":18604.65,"sFtime":"0:03","origRequest":{"legFwd":424691,"legIDs":[424691]}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KFLL.KTEB.22.01.10.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: 'b13e7f38-a579-451a-939c-d63b934d1965',
        requestId: 12778635,
        invoiceState: null,
        searchParams:
          '{"seg":["KFLL.KTEB.22.01.10.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: 'cd6fcacd-91b0-473d-84a2-f6912d141841',
        requestUrl: 'https://console.vista.studio/#fl:12778635',
        requestTime: '2022-01-05T18:39:07.399832+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 9,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2022-01-10T05:00:00+00:00',
      clientId: 1705839,
      requestId: 12778636,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:424692',
      flightRequestUrl: 'https://console.vista.studio/#fl:12778639',
      requestUrl: 'https://console.vista.studio/#l:12778640',
      flightRequestId: 12778639,
      legId: 424692,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12778639,
        clientId: 1705839,
        amount: 250,
        legId: 424692,
        legRequestId: 12778640,
      },
      flightRequest: {
        status: 101,
        updateTime: '2022-01-05T19:58:31.766239+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 0,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/26565',
            createTime: '2022-01-05T19:57:50.473223+00:00',
            formUrlKey: 'cfb29fc6-f838-46e5-980c-a4484892b158',
            clientSource: '2',
            formTplId: 359,
            id: 594883,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?cfb29fc6-f838-46e5-980c-a4484892b158',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?cfb29fc6-f838-46e5-980c-a4484892b158',
          },
          {
            totalPrice: 0,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/26566',
            createTime: '2022-01-05T20:05:42.890346+00:00',
            formUrlKey: 'a7be4177-f94b-4bf8-9666-0c2b7e1023fb',
            clientSource: '2',
            formTplId: 362,
            id: 594885,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?a7be4177-f94b-4bf8-9666-0c2b7e1023fb',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/?a7be4177-f94b-4bf8-9666-0c2b7e1023fb',
          },
          {
            totalPrice: 0,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/26567',
            createTime: '2022-01-05T20:08:01.419503+00:00',
            formUrlKey: '81455ffb-6663-4902-8200-43361dbc0577',
            clientSource: '2',
            formTplId: 360,
            id: 594887,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add/edit/?81455ffb-6663-4902-8200-43361dbc0577',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add/?81455ffb-6663-4902-8200-43361dbc0577',
          },
          {
            totalPrice: 11000,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/26568',
            createTime: '2022-01-05T20:23:50.242930+00:00',
            formUrlKey: '07b34d58-6168-47b5-ba47-5911dad448dc',
            clientSource: '2',
            formTplId: 362,
            id: 594891,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?07b34d58-6168-47b5-ba47-5911dad448dc',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/?07b34d58-6168-47b5-ba47-5911dad448dc',
          },
        ],
        orderItemTotal: 11000,
        invoiceData: null,
        departureDate: '2022-01-10T00:00:00',
        assignedOperator: 2040155,
        total: '20000',
        requestText:
          '{"ftime":3,"ftime_seg_max":3,"img":[],"title":"Falcon 2000","tailNumber":"N234FJ","pax":2,"yom":1996,"safety_rating":{"argusSafety":"Platinum","wyvernSafety":"Wingman"},"price":18604.65,"taxes":{"fetTax":1395.3488372093022},"amount":null,"src":null,"operator":{"id":"4a922f6c-92c2-4137-8e62-b4e4e0efaabd","name":"MAINE AVIATION AIRCRAFT CHARTER LLC"},"reqLegData":[{"from":{"city":"Ft Lauderdale","country":"United States","iata":"FLL","icao":"KFLL","lon":-80.1527414,"lat":26.0725961,"name":"Hollywood Intl","tz":-14400000,"tzn":"America/New_York"},"to":{"city":"Teterboro","country":"United States","iata":"TEB","icao":"KTEB","lon":-74.0608361,"lat":40.8501014,"name":"Teterboro","tz":-14400000,"tzn":"America/New_York"},"date":"2022-01-10T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":20000,"unitQuantity":1,"unitPercentage":null,"amount":20000,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KFLL","destination":"KTEB","departing":"2022-01-10T05:00:00.000Z","departingLocal":"2022-01-10T00:00:00.000Z","arrivingLocal":"2022-01-10T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":18604.65,"nonMemberPrice":18604.65,"original_price":18604.65,"sFtime":"0:03","origRequest":{"legFwd":424692,"legIDs":[424692]}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KFLL.KTEB.22.01.10.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '6b0b074c-558d-4e12-ad0d-2991ae456d79',
        requestId: 12778639,
        invoiceState: null,
        searchParams:
          '{"seg":["KFLL.KTEB.22.01.10.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: 'cd6fcacd-91b0-473d-84a2-f6912d141841',
        requestUrl: 'https://console.vista.studio/#fl:12778639',
        requestTime: '2022-01-05T19:57:44.180051+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 9,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2022-01-10T05:00:00+00:00',
      clientId: 1705839,
      requestId: 12778640,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:424693',
      flightRequestUrl: 'https://console.vista.studio/#fl:12778653',
      requestUrl: 'https://console.vista.studio/#l:12778654',
      flightRequestId: 12778653,
      legId: 424693,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12778653,
        clientId: 1705839,
        amount: 250,
        legId: 424693,
        legRequestId: 12778654,
      },
      flightRequest: {
        status: 101,
        updateTime: '2022-01-05T21:06:31.600498+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 0,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/26569',
            createTime: '2022-01-05T21:05:11.949876+00:00',
            formUrlKey: '48e57d17-3dd8-4cb7-a9c6-ebc4aff098a5',
            clientSource: '2',
            formTplId: 359,
            id: 594893,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?48e57d17-3dd8-4cb7-a9c6-ebc4aff098a5',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?48e57d17-3dd8-4cb7-a9c6-ebc4aff098a5',
          },
          {
            totalPrice: 0,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/26570',
            createTime: '2022-01-05T21:11:30.941327+00:00',
            formUrlKey: 'b5e072f5-d6a4-401f-8147-29236850676e',
            clientSource: '2',
            formTplId: 362,
            id: 594895,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?b5e072f5-d6a4-401f-8147-29236850676e',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/?b5e072f5-d6a4-401f-8147-29236850676e',
          },
        ],
        orderItemTotal: 0,
        invoiceData: null,
        departureDate: '2022-01-10T00:00:00',
        assignedOperator: 2040155,
        total: '20000',
        requestText:
          '{"ftime":3,"ftime_seg_max":3,"img":[],"title":"Falcon 2000","tailNumber":"N234FJ","pax":2,"yom":1996,"safety_rating":{"argusSafety":"Platinum","wyvernSafety":"Wingman"},"price":18604.65,"taxes":{"fetTax":1395.3488372093022},"amount":null,"src":null,"operator":{"id":"4a922f6c-92c2-4137-8e62-b4e4e0efaabd","name":"MAINE AVIATION AIRCRAFT CHARTER LLC"},"reqLegData":[{"from":{"city":"Ft Lauderdale","country":"United States","iata":"FLL","icao":"KFLL","lon":-80.1527414,"lat":26.0725961,"name":"Hollywood Intl","tz":-14400000,"tzn":"America/New_York"},"to":{"city":"Teterboro","country":"United States","iata":"TEB","icao":"KTEB","lon":-74.0608361,"lat":40.8501014,"name":"Teterboro","tz":-14400000,"tzn":"America/New_York"},"date":"2022-01-10T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":20000,"unitQuantity":1,"unitPercentage":null,"amount":20000,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KFLL","destination":"KTEB","departing":"2022-01-10T05:00:00.000Z","departingLocal":"2022-01-10T00:00:00.000Z","arrivingLocal":"2022-01-10T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":18604.65,"nonMemberPrice":18604.65,"original_price":18604.65,"sFtime":"0:03","origRequest":{"legFwd":424693,"legIDs":[424693]}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KFLL.KTEB.22.01.10.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '9af84497-e605-4b3f-9422-5ce6ce94766b',
        requestId: 12778653,
        invoiceState: null,
        searchParams:
          '{"seg":["KFLL.KTEB.22.01.10.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: 'cd6fcacd-91b0-473d-84a2-f6912d141841',
        requestUrl: 'https://console.vista.studio/#fl:12778653',
        requestTime: '2022-01-05T21:05:03.453680+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 5,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2022-01-10T05:00:00+00:00',
      clientId: 1705839,
      requestId: 12778654,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:424746',
      flightRequestUrl: 'https://console.vista.studio/#fl:12778740',
      requestUrl: 'https://console.vista.studio/#l:12778741',
      flightRequestId: 12778740,
      legId: 424746,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12778740,
        clientId: 1705839,
        amount: 250,
        legId: 424746,
        legRequestId: 12778741,
      },
      flightRequest: {
        status: 101,
        updateTime: '2022-01-06T20:59:38.667489+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 0,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/26577',
            createTime: '2022-01-06T20:58:59.528549+00:00',
            formUrlKey: '70406085-c0a6-4f04-ae36-65ca0d91539f',
            clientSource: '2',
            formTplId: 359,
            id: 594930,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?70406085-c0a6-4f04-ae36-65ca0d91539f',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?70406085-c0a6-4f04-ae36-65ca0d91539f',
          },
        ],
        orderItemTotal: 0,
        invoiceData: null,
        departureDate: '2022-01-10T00:00:00',
        assignedOperator: 2040155,
        total: '20000',
        requestText:
          '{"ftime":3,"ftime_seg_max":3,"img":[],"title":"Falcon 2000","tailNumber":"N234FJ","pax":2,"yom":1996,"safety_rating":{"argusSafety":"Platinum","wyvernSafety":"Wingman"},"price":18604.65,"taxes":{"fetTax":1395.3488372093022},"amount":null,"src":null,"operator":{"id":"4a922f6c-92c2-4137-8e62-b4e4e0efaabd","name":"MAINE AVIATION AIRCRAFT CHARTER LLC"},"reqLegData":[{"from":{"city":"Ft Lauderdale","country":"United States","iata":"FLL","icao":"KFLL","lon":-80.1527414,"lat":26.0725961,"name":"Hollywood Intl","tz":-14400000,"tzn":"America/New_York"},"to":{"city":"Teterboro","country":"United States","iata":"TEB","icao":"KTEB","lon":-74.0608361,"lat":40.8501014,"name":"Teterboro","tz":-14400000,"tzn":"America/New_York"},"date":"2022-01-10T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":20000,"unitQuantity":1,"unitPercentage":null,"amount":20000,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KFLL","destination":"KTEB","departing":"2022-01-10T05:00:00.000Z","departingLocal":"2022-01-10T00:00:00.000Z","arrivingLocal":"2022-01-10T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":18604.65,"nonMemberPrice":18604.65,"original_price":18604.65,"sFtime":"0:03","origRequest":{"legFwd":424746,"legIDs":[424746]}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KFLL.KTEB.22.01.10.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '425215bd-d2f4-4072-9da6-4604681937a3',
        requestId: 12778740,
        invoiceState: null,
        searchParams:
          '{"seg":["KFLL.KTEB.22.01.10.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: 'cd6fcacd-91b0-473d-84a2-f6912d141841',
        requestUrl: 'https://console.vista.studio/#fl:12778740',
        requestTime: '2022-01-06T20:58:54.297700+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 8,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2022-01-10T05:00:00+00:00',
      clientId: 1705839,
      requestId: 12778741,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:424918',
      flightRequestUrl: 'https://console.vista.studio/#fl:12779014',
      requestUrl: 'https://console.vista.studio/#l:12779015',
      flightRequestId: 12779014,
      legId: 424918,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12779014,
        clientId: 1705839,
        amount: 250,
        legId: 424918,
        legRequestId: 12779015,
      },
      flightRequest: {
        status: 101,
        updateTime: '2022-01-10T22:20:13.379117+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 0,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/26628',
            createTime: '2022-01-10T22:18:31.384704+00:00',
            formUrlKey: '9c1ccce6-4eb4-44f9-92df-27592ef864b8',
            clientSource: '2',
            formTplId: 359,
            id: 595027,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?9c1ccce6-4eb4-44f9-92df-27592ef864b8',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?9c1ccce6-4eb4-44f9-92df-27592ef864b8',
          },
          {
            totalPrice: 0,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/26629',
            createTime: '2022-01-10T22:23:37.646670+00:00',
            formUrlKey: '54a7b210-7454-44ed-b7a4-93838a16f2ac',
            clientSource: '2',
            formTplId: 362,
            id: 595029,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?54a7b210-7454-44ed-b7a4-93838a16f2ac',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/?54a7b210-7454-44ed-b7a4-93838a16f2ac',
          },
          {
            totalPrice: 0,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/26630',
            createTime: '2022-01-10T22:33:54.393231+00:00',
            formUrlKey: '40ef395a-c91d-413a-b437-f4f2e0c0819c',
            clientSource: '2',
            formTplId: 360,
            id: 595031,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add/edit/?40ef395a-c91d-413a-b437-f4f2e0c0819c',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add/?40ef395a-c91d-413a-b437-f4f2e0c0819c',
          },
          {
            totalPrice: 13768.8,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/26631',
            createTime: '2022-01-10T22:41:49.231644+00:00',
            formUrlKey: 'b878f8c4-5a93-4e73-8647-ff48403cde92',
            clientSource: '2',
            formTplId: 362,
            id: 595033,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?b878f8c4-5a93-4e73-8647-ff48403cde92',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/?b878f8c4-5a93-4e73-8647-ff48403cde92',
          },
        ],
        orderItemTotal: 13768.8,
        invoiceData: null,
        departureDate: '2022-01-10T00:00:00',
        assignedOperator: 2040155,
        total: '20000',
        requestText:
          '{"ftime":3,"ftime_seg_max":3,"img":[],"title":"Falcon 2000","tailNumber":"N234FJ","pax":2,"yom":1996,"safety_rating":{"argusSafety":"Platinum","wyvernSafety":"Wingman"},"price":18604.65,"taxes":{"fetTax":1395.3488372093022},"amount":null,"src":null,"operator":{"id":"4a922f6c-92c2-4137-8e62-b4e4e0efaabd","name":"MAINE AVIATION AIRCRAFT CHARTER LLC"},"reqLegData":[{"from":{"city":"Ft Lauderdale","country":"United States","iata":"FLL","icao":"KFLL","lon":-80.1527414,"lat":26.0725961,"name":"Hollywood Intl","tz":-14400000,"tzn":"America/New_York"},"to":{"city":"Teterboro","country":"United States","iata":"TEB","icao":"KTEB","lon":-74.0608361,"lat":40.8501014,"name":"Teterboro","tz":-14400000,"tzn":"America/New_York"},"date":"2022-01-10T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":20000,"unitQuantity":1,"unitPercentage":null,"amount":20000,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KFLL","destination":"KTEB","departing":"2022-01-10T05:00:00.000Z","departingLocal":"2022-01-10T00:00:00.000Z","arrivingLocal":"2022-01-10T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":18604.65,"nonMemberPrice":18604.65,"original_price":18604.65,"sFtime":"0:03","origRequest":{"legFwd":424918,"legIDs":[424918]}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KFLL.KTEB.22.01.10.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '70bea0eb-6697-467d-8ec6-d9968e3f0716',
        requestId: 12779014,
        invoiceState: null,
        searchParams:
          '{"seg":["KFLL.KTEB.22.01.10.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: 'cd6fcacd-91b0-473d-84a2-f6912d141841',
        requestUrl: 'https://console.vista.studio/#fl:12779014',
        requestTime: '2022-01-10T22:18:23.319343+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 9,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2022-01-10T05:00:00+00:00',
      clientId: 1705839,
      requestId: 12779015,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:425507',
      flightRequestUrl: 'https://console.vista.studio/#fl:12781299',
      requestUrl: 'https://console.vista.studio/#l:12781300',
      flightRequestId: 12781299,
      legId: 425507,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12781299,
        clientId: 1705839,
        amount: 250,
        legId: 425507,
        legRequestId: 12781300,
      },
      flightRequest: {
        status: 101,
        updateTime: '2022-01-24T21:20:35.119974+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 0,
            orderPaymentStatus: 7,
            orderUrl: 'http://localhost:3000/sales/orders/26889',
            createTime: '2022-01-24T20:55:55.447265+00:00',
            formUrlKey: '0434606c-9c19-4036-add3-0dcda3cacdd0',
            clientSource: '2',
            formTplId: 359,
            id: 595558,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?0434606c-9c19-4036-add3-0dcda3cacdd0',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?0434606c-9c19-4036-add3-0dcda3cacdd0',
          },
        ],
        orderItemTotal: 0,
        invoiceData: null,
        departureDate: '2022-01-10T00:00:00',
        assignedOperator: 2040155,
        total: '25087.13',
        requestText:
          '{"ftime":3,"ftime_seg_max":3,"img":[],"title":"Falcon 2000","tailNumber":"N234FJ","pax":2,"yom":1996,"safety_rating":{"argusSafety":"Platinum","wyvernSafety":"Wingman"},"price":23336.86,"taxes":{"fetTax":1750.2648837209304},"amount":null,"src":null,"operator":{"id":"4a922f6c-92c2-4137-8e62-b4e4e0efaabd","name":"MAINE AVIATION AIRCRAFT CHARTER LLC"},"reqLegData":[{"from":{"city":"Ft Lauderdale","country":"United States","iata":"FLL","icao":"KFLL","lon":-80.1527414,"lat":26.0725961,"name":"Hollywood Intl","tz":-14400000,"tzn":"America/New_York"},"to":{"city":"Teterboro","country":"United States","iata":"TEB","icao":"KTEB","lon":-74.0608361,"lat":40.8501014,"name":"Teterboro","tz":-14400000,"tzn":"America/New_York"},"date":"2022-01-10T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":23295,"unitQuantity":1,"unitPercentage":null,"amount":23295,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":23295,"unitQuantity":null,"unitPercentage":7.5,"amount":1747.13,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.5,"unitPercentage":null},"unitBasePrice":4.5,"unitQuantity":10,"unitPercentage":null,"amount":45,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KFLL","destination":"KTEB","departing":"2022-01-10T05:00:00.000Z","departingLocal":"2022-01-10T00:00:00.000Z","arrivingLocal":"2022-01-10T03:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":23336.86,"nonMemberPrice":23336.86,"original_price":23336.86,"sFtime":"0:03","origRequest":{"legFwd":425507,"legIDs":[425507]}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KFLL.KTEB.22.01.10.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: 'a9893d1e-59c5-465b-80b6-6fc702f382c1',
        requestId: 12781299,
        invoiceState: null,
        searchParams:
          '{"seg":["KFLL.KTEB.22.01.10.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: 'cd6fcacd-91b0-473d-84a2-f6912d141841',
        requestUrl: 'https://console.vista.studio/#fl:12781299',
        requestTime: '2022-01-24T20:55:49.107488+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 5,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2022-01-10T05:00:00+00:00',
      clientId: 1705839,
      requestId: 12781300,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:429276',
      flightRequestUrl: 'https://console.vista.studio/#fl:12788378',
      requestUrl: 'https://console.vista.studio/#l:12788379',
      flightRequestId: 12788378,
      legId: 429276,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12788378,
        clientId: 1705839,
        amount: 250,
        legId: 429276,
        legRequestId: 12788379,
      },
      flightRequest: {
        status: 104,
        updateTime: '2022-03-15T00:32:40.987223+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 24761,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/28807',
            createTime: '2022-03-15T00:04:42.061104+00:00',
            formUrlKey: '811efa0a-6fd6-4d16-a27f-383b4e6032c0',
            clientSource: '2',
            formTplId: 359,
            id: 597613,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?811efa0a-6fd6-4d16-a27f-383b4e6032c0',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?811efa0a-6fd6-4d16-a27f-383b4e6032c0',
          },
          {
            totalPrice: 24000,
            orderPaymentStatus: 7,
            orderUrl: 'http://localhost:3000/sales/orders/28808',
            createTime: '2022-03-15T00:19:54.418363+00:00',
            formUrlKey: '14757875-7cc6-4969-99ff-d064db028046',
            clientSource: '2',
            formTplId: 362,
            id: 597615,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?14757875-7cc6-4969-99ff-d064db028046',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/?14757875-7cc6-4969-99ff-d064db028046',
          },
          {
            totalPrice: 1000,
            orderPaymentStatus: 6,
            orderUrl: 'http://localhost:3000/sales/orders/28810',
            createTime: '2022-03-15T01:06:22.320414+00:00',
            formUrlKey: 'b21a1c64-56cb-4148-9abb-ba7cb3015bfc',
            clientSource: '2',
            formTplId: 360,
            id: 597619,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add/edit/?b21a1c64-56cb-4148-9abb-ba7cb3015bfc',
            invoicePaymentStatus: 2,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add/?b21a1c64-56cb-4148-9abb-ba7cb3015bfc',
          },
        ],
        orderItemTotal: 1000,
        invoiceData: null,
        departureDate: '2022-04-12T00:00:00',
        assignedOperator: 2040155,
        total: '24761',
        requestText:
          '{"ftime":3,"ftime_seg_max":3,"img":[],"title":"Super Mid Size Jet","tailNumber":"#XOJET-SUPERMID","pax":2,"yom":2008,"safety_rating":{"argusSafety":null,"wyvernSafety":null},"price":23033.48,"taxes":{"fetTax":1727.5116279069769},"amount":null,"src":"xojet","operator":{"id":"b9733070-7de2-435b-9054-b85efe88042f","name":"XOJet, Inc."},"serviceClass":"XO DEDICATED FLEET","reqLegData":[{"from":{"city":"Ft Lauderdale","country":"United States","iata":"FLL","icao":"KFLL","lon":-80.1527414,"lat":26.0725961,"name":"Hollywood Intl","tz":-14400000,"tzn":"America/New_York"},"to":{"city":"Denver","country":"United States","iata":"DEN","icao":"KDEN","lon":-104.6731667,"lat":39.8616667,"name":"Denver Intl","tz":-21600000,"tzn":"America/Denver"},"date":"2022-04-12T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":23000,"unitQuantity":1,"unitPercentage":null,"amount":23000,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":23000,"unitQuantity":null,"unitPercentage":7.5,"amount":1725,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.5,"unitPercentage":null},"unitBasePrice":4.5,"unitQuantity":8,"unitPercentage":null,"amount":36,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KFLL","destination":"KDEN","departing":"2022-04-12T04:00:00.000Z","departingLocal":"2022-04-12T00:00:00.000Z","arrivingLocal":"2022-04-12T01:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":23033.48,"nonMemberPrice":23033.48,"original_price":23033.48,"sFtime":"0:03","origRequest":{"legFwd":429276,"legIDs":[429276]}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KFLL.KDEN.22.04.12.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '06a7b41a-1cfb-494f-8d5c-e68ba968a945',
        requestId: 12788378,
        invoiceState: null,
        searchParams:
          '{"seg":["KFLL.KDEN.22.04.12.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: 'df6ba53a-f310-44ee-80f8-029213e62ea6',
        requestUrl: 'https://console.vista.studio/#fl:12788378',
        requestTime: '2022-03-15T00:04:34.907995+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 3,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2022-04-12T04:00:00+00:00',
      clientId: 1705839,
      requestId: 12788379,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:429536',
      flightRequestUrl: 'https://console.vista.studio/#fl:12788808',
      requestUrl: 'https://console.vista.studio/#l:12788940',
      flightRequestId: 12788808,
      legId: 429536,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12788808,
        clientId: 1705839,
        amount: 250,
        legId: 429536,
        legRequestId: 12788940,
      },
      flightRequest: {
        status: 101,
        updateTime: '2022-03-17T12:43:29.407559+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 37436.12,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/28936',
            createTime: '2022-03-17T04:10:45.124158+00:00',
            formUrlKey: '7ef70624-c5d7-4862-9b67-0e8803a62452',
            clientSource: '2',
            formTplId: 359,
            id: 597829,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?7ef70624-c5d7-4862-9b67-0e8803a62452',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?7ef70624-c5d7-4862-9b67-0e8803a62452',
          },
          {
            totalPrice: 37436.12,
            orderPaymentStatus: -1,
            createTime: '2022-03-17T16:21:21.542535+00:00',
            formUrlKey: '4ebee999-e97c-4dab-8e0f-3c71892a19de',
            clientSource: '2',
            formTplId: 361,
            id: 597925,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_mod/edit/?4ebee999-e97c-4dab-8e0f-3c71892a19de',
            invoicePaymentStatus: 2,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_mod/?4ebee999-e97c-4dab-8e0f-3c71892a19de',
          },
        ],
        orderItemTotal: 37436.12,
        invoiceData: null,
        departureDate: '2022-04-12T00:00:00',
        assignedOperator: 2040155,
        total: '37436.13',
        requestText:
          '{"ftime":3,"ftime_seg_max":3,"img":[],"title":"Citation Ultra","tailNumber":"CITATION ULTRA","pax":2,"yom":1998,"safety_rating":{"argusSafety":null,"wyvernSafety":null},"price":34824.3,"taxes":{"fetTax":2611.823023255814},"amount":null,"src":"redwing","operator":{"id":"b54f7620-3436-419f-a3ff-c43cd1f3d82f","name":"RED WING AEROPLANE COMPANY"},"reqLegData":[{"from":{"city":"Ft Lauderdale","country":"United States","iata":"FLL","icao":"KFLL","lon":-80.1527414,"lat":26.0725961,"name":"Hollywood Intl","tz":-14400000,"tzn":"America/New_York"},"to":{"city":"Denver","country":"United States","iata":"DEN","icao":"KDEN","lon":-104.6731667,"lat":39.8616667,"name":"Denver Intl","tz":-21600000,"tzn":"America/Denver"},"date":"2022-04-12T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":34795,"unitQuantity":1,"unitPercentage":null,"amount":34795,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":34795,"unitQuantity":null,"unitPercentage":7.5,"amount":2609.63,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.5,"unitPercentage":null},"unitBasePrice":4.5,"unitQuantity":7,"unitPercentage":null,"amount":31.5,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KFLL","destination":"KDEN","departing":"2022-04-12T04:00:00.000Z","departingLocal":"2022-04-12T00:00:00.000Z","arrivingLocal":"2022-04-12T01:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":34824.3,"nonMemberPrice":34824.3,"original_price":34824.3,"sFtime":"0:03","origRequest":{"legFwd":429536,"legIDs":[429536]}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KFLL.KDEN.22.04.12.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '13264155-f9fa-4046-b5ac-ccc6e4ff7ef5',
        requestId: 12788808,
        invoiceState: null,
        searchParams:
          '{"seg":["KFLL.KDEN.22.04.12.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: 'df6ba53a-f310-44ee-80f8-029213e62ea6',
        requestUrl: 'https://console.vista.studio/#fl:12788808',
        requestTime: '2022-03-17T04:10:37.172548+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 6,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2022-04-12T04:00:00+00:00',
      clientId: 1705839,
      requestId: 12788940,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:429567',
      flightRequestUrl: 'https://console.vista.studio/#fl:12789030',
      requestUrl: 'https://console.vista.studio/#l:12789032',
      flightRequestId: 12789030,
      legId: 429567,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12789030,
        clientId: 1705839,
        amount: 250,
        legId: 429567,
        legRequestId: 12789032,
      },
      flightRequest: {
        status: 101,
        updateTime: '2022-03-17T16:28:22.652918+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 37436.12,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/28998',
            createTime: '2022-03-17T16:24:14.804929+00:00',
            formUrlKey: '0a2fd611-0584-41c9-a679-597e237835a3',
            clientSource: '2',
            formTplId: 359,
            id: 597928,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?0a2fd611-0584-41c9-a679-597e237835a3',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?0a2fd611-0584-41c9-a679-597e237835a3',
          },
          {
            totalPrice: 37436.12,
            orderPaymentStatus: -1,
            createTime: '2022-03-18T10:05:02.288264+00:00',
            formUrlKey: 'f9d30aa3-5d53-4af6-9b31-9bed9810713e',
            clientSource: '2',
            formTplId: 361,
            id: 597956,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_mod/edit/?f9d30aa3-5d53-4af6-9b31-9bed9810713e',
            invoicePaymentStatus: 2,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_mod/?f9d30aa3-5d53-4af6-9b31-9bed9810713e',
          },
        ],
        orderItemTotal: 37436.12,
        invoiceData: null,
        departureDate: '2022-04-12T00:00:00',
        assignedOperator: 2040155,
        total: '37436.13',
        requestText:
          '{"ftime":3,"ftime_seg_max":3,"img":[],"title":"Citation Ultra","tailNumber":"CITATION ULTRA","pax":2,"yom":1998,"safety_rating":{"argusSafety":null,"wyvernSafety":null},"price":34824.3,"taxes":{"fetTax":2611.823023255814},"amount":null,"src":"redwing","operator":{"id":"b54f7620-3436-419f-a3ff-c43cd1f3d82f","name":"RED WING AEROPLANE COMPANY"},"reqLegData":[{"from":{"city":"Ft Lauderdale","country":"United States","iata":"FLL","icao":"KFLL","lon":-80.1527414,"lat":26.0725961,"name":"Hollywood Intl","tz":-14400000,"tzn":"America/New_York"},"to":{"city":"Denver","country":"United States","iata":"DEN","icao":"KDEN","lon":-104.6731667,"lat":39.8616667,"name":"Denver Intl","tz":-21600000,"tzn":"America/Denver"},"date":"2022-04-12T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":34795,"unitQuantity":1,"unitPercentage":null,"amount":34795,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":34795,"unitQuantity":null,"unitPercentage":7.5,"amount":2609.63,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.5,"unitPercentage":null},"unitBasePrice":4.5,"unitQuantity":7,"unitPercentage":null,"amount":31.5,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KFLL","destination":"KDEN","departing":"2022-04-12T04:00:00.000Z","departingLocal":"2022-04-12T00:00:00.000Z","arrivingLocal":"2022-04-12T01:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":34824.3,"nonMemberPrice":34824.3,"original_price":34824.3,"sFtime":"0:03","origRequest":{"legFwd":429567,"legIDs":[429567]}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KFLL.KDEN.22.04.12.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: 'd43e3925-8a5e-47e5-86fb-560cbf58b36c',
        requestId: 12789030,
        invoiceState: null,
        searchParams:
          '{"seg":["KFLL.KDEN.22.04.12.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: 'df6ba53a-f310-44ee-80f8-029213e62ea6',
        requestUrl: 'https://console.vista.studio/#fl:12789030',
        requestTime: '2022-03-17T16:24:07.425458+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 6,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2022-04-12T04:00:00+00:00',
      clientId: 1705839,
      requestId: 12789032,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:429628',
      flightRequestUrl: 'https://console.vista.studio/#fl:12789232',
      requestUrl: 'https://console.vista.studio/#l:12789233',
      flightRequestId: 12789232,
      legId: 429628,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12789232,
        clientId: 1705839,
        amount: 250,
        legId: 429628,
        legRequestId: 12789233,
      },
      flightRequest: {
        status: 101,
        updateTime: '2022-03-18T12:09:45.017124+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 37436.13,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/29020',
            createTime: '2022-03-18T12:08:12.978661+00:00',
            formUrlKey: '939e1773-ed03-42af-a3d4-4776556f59a6',
            clientSource: '2',
            formTplId: 359,
            id: 597979,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?939e1773-ed03-42af-a3d4-4776556f59a6',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?939e1773-ed03-42af-a3d4-4776556f59a6',
          },
          {
            totalPrice: 37436.13,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/29021',
            createTime: '2022-03-18T12:11:49.443990+00:00',
            formUrlKey: 'ad15a6b7-baec-473b-8c42-5ddb1842c271',
            clientSource: '2',
            formTplId: 362,
            id: 597981,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?ad15a6b7-baec-473b-8c42-5ddb1842c271',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/?ad15a6b7-baec-473b-8c42-5ddb1842c271',
          },
        ],
        orderItemTotal: 37436.13,
        invoiceData: null,
        departureDate: '2022-04-12T00:00:00',
        assignedOperator: 2040155,
        total: '37436.13',
        requestText:
          '{"ftime":3,"ftime_seg_max":3,"img":[],"title":"Citation Ultra","tailNumber":"CITATION ULTRA","pax":2,"yom":1998,"safety_rating":{"argusSafety":null,"wyvernSafety":null},"price":34824.3,"taxes":{"fetTax":2611.823023255814},"amount":null,"src":"redwing","operator":{"id":"b54f7620-3436-419f-a3ff-c43cd1f3d82f","name":"RED WING AEROPLANE COMPANY"},"reqLegData":[{"from":{"city":"Ft Lauderdale","country":"United States","iata":"FLL","icao":"KFLL","lon":-80.1527414,"lat":26.0725961,"name":"Hollywood Intl","tz":-14400000,"tzn":"America/New_York"},"to":{"city":"Denver","country":"United States","iata":"DEN","icao":"KDEN","lon":-104.6731667,"lat":39.8616667,"name":"Denver Intl","tz":-21600000,"tzn":"America/Denver"},"date":"2022-04-12T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":34795,"unitQuantity":1,"unitPercentage":null,"amount":34795,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":34795,"unitQuantity":null,"unitPercentage":7.5,"amount":2609.63,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.5,"unitPercentage":null},"unitBasePrice":4.5,"unitQuantity":7,"unitPercentage":null,"amount":31.5,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KFLL","destination":"KDEN","departing":"2022-04-12T04:00:00.000Z","departingLocal":"2022-04-12T00:00:00.000Z","arrivingLocal":"2022-04-12T01:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":34824.3,"nonMemberPrice":34824.3,"original_price":34824.3,"sFtime":"0:03","origRequest":{"legFwd":429628,"legIDs":[429628]}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KFLL.KDEN.22.04.12.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: 'b1b1c015-3657-4434-be18-ee728c42dd41',
        requestId: 12789232,
        invoiceState: null,
        searchParams:
          '{"seg":["KFLL.KDEN.22.04.12.00.00"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: 'df6ba53a-f310-44ee-80f8-029213e62ea6',
        requestUrl: 'https://console.vista.studio/#fl:12789232',
        requestTime: '2022-03-18T12:08:05.470268+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 5,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2022-04-12T04:00:00+00:00',
      clientId: 1705839,
      requestId: 12789233,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:429818',
      flightRequestUrl: 'https://console.vista.studio/#fl:12789485',
      requestUrl: 'https://console.vista.studio/#l:12789487',
      flightRequestId: 12789485,
      legId: 429818,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12789485,
        clientId: 1705839,
        amount: 250,
        legId: 429818,
        legRequestId: 12789487,
      },
      flightRequest: {
        status: 101,
        updateTime: '2022-03-21T14:16:25.667786+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 36211.44,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/29060',
            createTime: '2022-03-21T14:10:42.503609+00:00',
            formUrlKey: '1b65de8c-2774-4b15-8725-5d05e525db95',
            clientSource: '2',
            formTplId: 359,
            id: 598058,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?1b65de8c-2774-4b15-8725-5d05e525db95',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?1b65de8c-2774-4b15-8725-5d05e525db95',
          },
          {
            totalPrice: 36211.44,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/29061',
            createTime: '2022-03-21T14:19:57.592931+00:00',
            formUrlKey: '74adefb1-08f2-4ffa-b5d2-8c7f32c9cd81',
            clientSource: '2',
            formTplId: 362,
            id: 598060,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?74adefb1-08f2-4ffa-b5d2-8c7f32c9cd81',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/?74adefb1-08f2-4ffa-b5d2-8c7f32c9cd81',
          },
          {
            totalPrice: 36211.44,
            orderPaymentStatus: -1,
            createTime: '2022-03-21T14:23:12.967889+00:00',
            formUrlKey: '853d0ec9-bafd-47f7-b518-382e2112a6a9',
            clientSource: '2',
            formTplId: 361,
            id: 598062,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_mod/edit/?853d0ec9-bafd-47f7-b518-382e2112a6a9',
            invoicePaymentStatus: 2,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_mod/?853d0ec9-bafd-47f7-b518-382e2112a6a9',
          },
        ],
        orderItemTotal: 36211.44,
        invoiceData: null,
        departureDate: '2022-04-12T00:00:00',
        assignedOperator: 2040155,
        total: '36131.31',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"Citation Ultra","tailNumber":"CITATION ULTRA","pax":3,"yom":1998,"safety_rating":{"argusSafety":null,"wyvernSafety":null},"price":33610.52,"taxes":{"fetTax":2520.7890697674416},"amount":null,"src":"redwing","operator":{"id":"b54f7620-3436-419f-a3ff-c43cd1f3d82f","name":"RED WING AEROPLANE COMPANY"},"reqLegData":[{"from":{"city":"Ft Lauderdale","country":"United States","iata":"FLL","icao":"KFLL","lon":-80.1527414,"lat":26.0725961,"name":"Hollywood Intl","tz":-14400000,"tzn":"America/New_York"},"to":{"city":"Denver","country":"United States","iata":"DEN","icao":"KDEN","lon":-104.6731667,"lat":39.8616667,"name":"Denver Intl","tz":-21600000,"tzn":"America/Denver"},"date":"2022-04-12T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":17397.5,"unitQuantity":1,"unitPercentage":null,"amount":17397.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":17397.5,"unitQuantity":null,"unitPercentage":7.5,"amount":1304.81,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.5,"unitPercentage":null},"unitBasePrice":4.5,"unitQuantity":7,"unitPercentage":null,"amount":31.5,"currency":"USD"}],"eft":3},{"from":{"city":"Denver","country":"United States","iata":"DEN","icao":"KDEN","lon":-104.6731667,"lat":39.8616667,"name":"Denver Intl","tz":-21600000,"tzn":"America/Denver"},"to":{"city":"Ft Lauderdale","country":"United States","iata":"FLL","icao":"KFLL","lon":-80.1527414,"lat":26.0725961,"name":"Hollywood Intl","tz":-14400000,"tzn":"America/New_York"},"date":"2022-03-27T16:10:09.000Z","time":16,"pax":3,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":17397.5,"unitQuantity":1,"unitPercentage":null,"amount":17397.5,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KFLL","destination":"KDEN","departing":"2022-04-12T04:00:00.000Z","departingLocal":"2022-04-12T00:00:00.000Z","arrivingLocal":"2022-04-12T01:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KDEN","destination":"KFLL","departing":"2022-03-27T22:10:09.000Z","departingLocal":"2022-03-27T16:10:09.000Z","arrivingLocal":"2022-03-27T21:10:09.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":33610.52,"nonMemberPrice":33610.52,"original_price":33610.52,"sFtime":"0:06","origRequest":{"legFwd":429818,"legIDs":[429818,429819],"legRet":429819}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KFLL.KDEN.22.04.12.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '7e65fc74-32b0-4b21-b2f9-e3d62f0782f0',
        requestId: 12789485,
        invoiceState: null,
        searchParams:
          '{"seg":["KFLL.KDEN.22.04.12.00.00","KDEN.KFLL.22.03.27.16.10"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: 'df6ba53a-f310-44ee-80f8-029213e62ea6',
        requestUrl: 'https://console.vista.studio/#fl:12789485',
        requestTime: '2022-03-21T14:10:34.576045+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 6,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2022-04-12T04:00:00+00:00',
      clientId: 1705839,
      requestId: 12789487,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:429819',
      flightRequestUrl: 'https://console.vista.studio/#fl:12789485',
      requestUrl: 'https://console.vista.studio/#l:12789488',
      flightRequestId: 12789485,
      legId: 429819,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12789485,
        clientId: 1705839,
        amount: 250,
        legId: 429819,
        legRequestId: 12789488,
      },
      flightRequest: {
        status: 101,
        updateTime: '2022-03-21T14:16:25.667786+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 36211.44,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/29060',
            createTime: '2022-03-21T14:10:42.503609+00:00',
            formUrlKey: '1b65de8c-2774-4b15-8725-5d05e525db95',
            clientSource: '2',
            formTplId: 359,
            id: 598058,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?1b65de8c-2774-4b15-8725-5d05e525db95',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?1b65de8c-2774-4b15-8725-5d05e525db95',
          },
          {
            totalPrice: 36211.44,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/29061',
            createTime: '2022-03-21T14:19:57.592931+00:00',
            formUrlKey: '74adefb1-08f2-4ffa-b5d2-8c7f32c9cd81',
            clientSource: '2',
            formTplId: 362,
            id: 598060,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?74adefb1-08f2-4ffa-b5d2-8c7f32c9cd81',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/?74adefb1-08f2-4ffa-b5d2-8c7f32c9cd81',
          },
          {
            totalPrice: 36211.44,
            orderPaymentStatus: -1,
            createTime: '2022-03-21T14:23:12.967889+00:00',
            formUrlKey: '853d0ec9-bafd-47f7-b518-382e2112a6a9',
            clientSource: '2',
            formTplId: 361,
            id: 598062,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_mod/edit/?853d0ec9-bafd-47f7-b518-382e2112a6a9',
            invoicePaymentStatus: 2,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_mod/?853d0ec9-bafd-47f7-b518-382e2112a6a9',
          },
        ],
        orderItemTotal: 36211.44,
        invoiceData: null,
        departureDate: '2022-04-12T00:00:00',
        assignedOperator: 2040155,
        total: '36131.31',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"Citation Ultra","tailNumber":"CITATION ULTRA","pax":3,"yom":1998,"safety_rating":{"argusSafety":null,"wyvernSafety":null},"price":33610.52,"taxes":{"fetTax":2520.7890697674416},"amount":null,"src":"redwing","operator":{"id":"b54f7620-3436-419f-a3ff-c43cd1f3d82f","name":"RED WING AEROPLANE COMPANY"},"reqLegData":[{"from":{"city":"Ft Lauderdale","country":"United States","iata":"FLL","icao":"KFLL","lon":-80.1527414,"lat":26.0725961,"name":"Hollywood Intl","tz":-14400000,"tzn":"America/New_York"},"to":{"city":"Denver","country":"United States","iata":"DEN","icao":"KDEN","lon":-104.6731667,"lat":39.8616667,"name":"Denver Intl","tz":-21600000,"tzn":"America/Denver"},"date":"2022-04-12T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":17397.5,"unitQuantity":1,"unitPercentage":null,"amount":17397.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":17397.5,"unitQuantity":null,"unitPercentage":7.5,"amount":1304.81,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.5,"unitPercentage":null},"unitBasePrice":4.5,"unitQuantity":7,"unitPercentage":null,"amount":31.5,"currency":"USD"}],"eft":3},{"from":{"city":"Denver","country":"United States","iata":"DEN","icao":"KDEN","lon":-104.6731667,"lat":39.8616667,"name":"Denver Intl","tz":-21600000,"tzn":"America/Denver"},"to":{"city":"Ft Lauderdale","country":"United States","iata":"FLL","icao":"KFLL","lon":-80.1527414,"lat":26.0725961,"name":"Hollywood Intl","tz":-14400000,"tzn":"America/New_York"},"date":"2022-03-27T16:10:09.000Z","time":16,"pax":3,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":17397.5,"unitQuantity":1,"unitPercentage":null,"amount":17397.5,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KFLL","destination":"KDEN","departing":"2022-04-12T04:00:00.000Z","departingLocal":"2022-04-12T00:00:00.000Z","arrivingLocal":"2022-04-12T01:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KDEN","destination":"KFLL","departing":"2022-03-27T22:10:09.000Z","departingLocal":"2022-03-27T16:10:09.000Z","arrivingLocal":"2022-03-27T21:10:09.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":33610.52,"nonMemberPrice":33610.52,"original_price":33610.52,"sFtime":"0:06","origRequest":{"legFwd":429818,"legIDs":[429818,429819],"legRet":429819}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KFLL.KDEN.22.04.12.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '7e65fc74-32b0-4b21-b2f9-e3d62f0782f0',
        requestId: 12789485,
        invoiceState: null,
        searchParams:
          '{"seg":["KFLL.KDEN.22.04.12.00.00","KDEN.KFLL.22.03.27.16.10"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: 'df6ba53a-f310-44ee-80f8-029213e62ea6',
        requestUrl: 'https://console.vista.studio/#fl:12789485',
        requestTime: '2022-03-21T14:10:34.576045+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 6,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2022-03-27T22:10:09+00:00',
      clientId: 1705839,
      requestId: 12789488,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:429834',
      flightRequestUrl: 'https://console.vista.studio/#fl:12789512',
      requestUrl: 'https://console.vista.studio/#l:12789516',
      flightRequestId: 12789512,
      legId: 429834,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12789512,
        clientId: 1705839,
        amount: 250,
        legId: 429834,
        legRequestId: 12789516,
      },
      flightRequest: {
        status: 101,
        updateTime: '2022-03-21T15:54:29.676415+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 36131.31,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/29074',
            createTime: '2022-03-21T15:51:21.607402+00:00',
            formUrlKey: 'b31a49cb-96e0-4566-b113-0868ab3d8297',
            clientSource: '2',
            formTplId: 359,
            id: 598076,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?b31a49cb-96e0-4566-b113-0868ab3d8297',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?b31a49cb-96e0-4566-b113-0868ab3d8297',
          },
          {
            totalPrice: 36131.31,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/29076',
            createTime: '2022-03-21T15:58:02.676580+00:00',
            formUrlKey: '85e4cef3-0862-4381-a9a2-7c49891822ec',
            clientSource: '2',
            formTplId: 362,
            id: 598079,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?85e4cef3-0862-4381-a9a2-7c49891822ec',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/?85e4cef3-0862-4381-a9a2-7c49891822ec',
          },
          {
            totalPrice: 36131.31,
            orderPaymentStatus: -1,
            createTime: '2022-03-21T15:59:55.009597+00:00',
            formUrlKey: 'aadd32fb-0514-4d63-803c-f82e38839b5d',
            clientSource: '2',
            formTplId: 361,
            id: 598080,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_mod/edit/?aadd32fb-0514-4d63-803c-f82e38839b5d',
            invoicePaymentStatus: 2,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_mod/?aadd32fb-0514-4d63-803c-f82e38839b5d',
          },
        ],
        orderItemTotal: 36131.31,
        invoiceData: null,
        departureDate: '2022-04-12T00:00:00',
        assignedOperator: 2040155,
        total: '36131.31',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"Citation Ultra","tailNumber":"CITATION ULTRA","pax":3,"yom":1998,"safety_rating":{"argusSafety":null,"wyvernSafety":null},"price":33610.52,"taxes":{"fetTax":2520.7890697674416},"amount":null,"src":"redwing","operator":{"id":"b54f7620-3436-419f-a3ff-c43cd1f3d82f","name":"RED WING AEROPLANE COMPANY"},"reqLegData":[{"from":{"city":"Ft Lauderdale","country":"United States","iata":"FLL","icao":"KFLL","lon":-80.1527414,"lat":26.0725961,"name":"Hollywood Intl","tz":-14400000,"tzn":"America/New_York"},"to":{"city":"Denver","country":"United States","iata":"DEN","icao":"KDEN","lon":-104.6731667,"lat":39.8616667,"name":"Denver Intl","tz":-21600000,"tzn":"America/Denver"},"date":"2022-04-12T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":17397.5,"unitQuantity":1,"unitPercentage":null,"amount":17397.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":17397.5,"unitQuantity":null,"unitPercentage":7.5,"amount":1304.81,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.5,"unitPercentage":null},"unitBasePrice":4.5,"unitQuantity":7,"unitPercentage":null,"amount":31.5,"currency":"USD"}],"eft":3},{"from":{"city":"Denver","country":"United States","iata":"DEN","icao":"KDEN","lon":-104.6731667,"lat":39.8616667,"name":"Denver Intl","tz":-21600000,"tzn":"America/Denver"},"to":{"city":"Ft Lauderdale","country":"United States","iata":"FLL","icao":"KFLL","lon":-80.1527414,"lat":26.0725961,"name":"Hollywood Intl","tz":-14400000,"tzn":"America/New_York"},"date":"2022-03-27T16:10:09.000Z","time":16,"pax":3,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":17397.5,"unitQuantity":1,"unitPercentage":null,"amount":17397.5,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KFLL","destination":"KDEN","departing":"2022-04-12T04:00:00.000Z","departingLocal":"2022-04-12T00:00:00.000Z","arrivingLocal":"2022-04-12T01:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KDEN","destination":"KFLL","departing":"2022-03-27T22:10:09.000Z","departingLocal":"2022-03-27T16:10:09.000Z","arrivingLocal":"2022-03-27T21:10:09.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":33610.52,"nonMemberPrice":33610.52,"original_price":33610.52,"sFtime":"0:06","origRequest":{"legFwd":429834,"legIDs":[429834,429835],"legRet":429835}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KFLL.KDEN.22.04.12.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '43de7530-230f-4d76-94ed-f6d2cdad5b3b',
        requestId: 12789512,
        invoiceState: null,
        searchParams:
          '{"seg":["KFLL.KDEN.22.04.12.00.00","KDEN.KFLL.22.03.27.16.10"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: 'df6ba53a-f310-44ee-80f8-029213e62ea6',
        requestUrl: 'https://console.vista.studio/#fl:12789512',
        requestTime: '2022-03-21T15:51:13.564904+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 6,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2022-04-12T04:00:00+00:00',
      clientId: 1705839,
      requestId: 12789516,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:429835',
      flightRequestUrl: 'https://console.vista.studio/#fl:12789512',
      requestUrl: 'https://console.vista.studio/#l:12789517',
      flightRequestId: 12789512,
      legId: 429835,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12789512,
        clientId: 1705839,
        amount: 250,
        legId: 429835,
        legRequestId: 12789517,
      },
      flightRequest: {
        status: 101,
        updateTime: '2022-03-21T15:54:29.676415+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 36131.31,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/29074',
            createTime: '2022-03-21T15:51:21.607402+00:00',
            formUrlKey: 'b31a49cb-96e0-4566-b113-0868ab3d8297',
            clientSource: '2',
            formTplId: 359,
            id: 598076,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?b31a49cb-96e0-4566-b113-0868ab3d8297',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?b31a49cb-96e0-4566-b113-0868ab3d8297',
          },
          {
            totalPrice: 36131.31,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/29076',
            createTime: '2022-03-21T15:58:02.676580+00:00',
            formUrlKey: '85e4cef3-0862-4381-a9a2-7c49891822ec',
            clientSource: '2',
            formTplId: 362,
            id: 598079,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?85e4cef3-0862-4381-a9a2-7c49891822ec',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/?85e4cef3-0862-4381-a9a2-7c49891822ec',
          },
          {
            totalPrice: 36131.31,
            orderPaymentStatus: -1,
            createTime: '2022-03-21T15:59:55.009597+00:00',
            formUrlKey: 'aadd32fb-0514-4d63-803c-f82e38839b5d',
            clientSource: '2',
            formTplId: 361,
            id: 598080,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_mod/edit/?aadd32fb-0514-4d63-803c-f82e38839b5d',
            invoicePaymentStatus: 2,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_mod/?aadd32fb-0514-4d63-803c-f82e38839b5d',
          },
        ],
        orderItemTotal: 36131.31,
        invoiceData: null,
        departureDate: '2022-04-12T00:00:00',
        assignedOperator: 2040155,
        total: '36131.31',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"Citation Ultra","tailNumber":"CITATION ULTRA","pax":3,"yom":1998,"safety_rating":{"argusSafety":null,"wyvernSafety":null},"price":33610.52,"taxes":{"fetTax":2520.7890697674416},"amount":null,"src":"redwing","operator":{"id":"b54f7620-3436-419f-a3ff-c43cd1f3d82f","name":"RED WING AEROPLANE COMPANY"},"reqLegData":[{"from":{"city":"Ft Lauderdale","country":"United States","iata":"FLL","icao":"KFLL","lon":-80.1527414,"lat":26.0725961,"name":"Hollywood Intl","tz":-14400000,"tzn":"America/New_York"},"to":{"city":"Denver","country":"United States","iata":"DEN","icao":"KDEN","lon":-104.6731667,"lat":39.8616667,"name":"Denver Intl","tz":-21600000,"tzn":"America/Denver"},"date":"2022-04-12T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":17397.5,"unitQuantity":1,"unitPercentage":null,"amount":17397.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":17397.5,"unitQuantity":null,"unitPercentage":7.5,"amount":1304.81,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.5,"unitPercentage":null},"unitBasePrice":4.5,"unitQuantity":7,"unitPercentage":null,"amount":31.5,"currency":"USD"}],"eft":3},{"from":{"city":"Denver","country":"United States","iata":"DEN","icao":"KDEN","lon":-104.6731667,"lat":39.8616667,"name":"Denver Intl","tz":-21600000,"tzn":"America/Denver"},"to":{"city":"Ft Lauderdale","country":"United States","iata":"FLL","icao":"KFLL","lon":-80.1527414,"lat":26.0725961,"name":"Hollywood Intl","tz":-14400000,"tzn":"America/New_York"},"date":"2022-03-27T16:10:09.000Z","time":16,"pax":3,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":17397.5,"unitQuantity":1,"unitPercentage":null,"amount":17397.5,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KFLL","destination":"KDEN","departing":"2022-04-12T04:00:00.000Z","departingLocal":"2022-04-12T00:00:00.000Z","arrivingLocal":"2022-04-12T01:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KDEN","destination":"KFLL","departing":"2022-03-27T22:10:09.000Z","departingLocal":"2022-03-27T16:10:09.000Z","arrivingLocal":"2022-03-27T21:10:09.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":33610.52,"nonMemberPrice":33610.52,"original_price":33610.52,"sFtime":"0:06","origRequest":{"legFwd":429834,"legIDs":[429834,429835],"legRet":429835}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KFLL.KDEN.22.04.12.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '43de7530-230f-4d76-94ed-f6d2cdad5b3b',
        requestId: 12789512,
        invoiceState: null,
        searchParams:
          '{"seg":["KFLL.KDEN.22.04.12.00.00","KDEN.KFLL.22.03.27.16.10"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: 'df6ba53a-f310-44ee-80f8-029213e62ea6',
        requestUrl: 'https://console.vista.studio/#fl:12789512',
        requestTime: '2022-03-21T15:51:13.564904+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 6,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2022-03-27T22:10:09+00:00',
      clientId: 1705839,
      requestId: 12789517,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:430016',
      flightRequestUrl: 'https://console.vista.studio/#fl:12789727',
      requestUrl: 'https://console.vista.studio/#l:12789731',
      flightRequestId: 12789727,
      legId: 430016,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12789727,
        clientId: 1705839,
        amount: 250,
        legId: 430016,
        legRequestId: 12789731,
      },
      flightRequest: {
        status: 101,
        updateTime: '2022-03-23T13:15:23.701609+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 37467.62,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/29161',
            createTime: '2022-03-23T13:09:10.195778+00:00',
            formUrlKey: 'b8da81eb-d998-4890-a823-ea4539a74406',
            clientSource: '2',
            formTplId: 359,
            id: 598205,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?b8da81eb-d998-4890-a823-ea4539a74406',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?b8da81eb-d998-4890-a823-ea4539a74406',
          },
          {
            totalPrice: 37467.62,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/29164',
            createTime: '2022-03-23T13:22:26.182877+00:00',
            formUrlKey: 'fe532126-76e9-4de4-b1ed-26b04b67fae3',
            clientSource: '2',
            formTplId: 362,
            id: 598208,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?fe532126-76e9-4de4-b1ed-26b04b67fae3',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/?fe532126-76e9-4de4-b1ed-26b04b67fae3',
          },
          {
            totalPrice: 37467.62,
            orderPaymentStatus: -1,
            createTime: '2022-03-23T13:26:06.124395+00:00',
            formUrlKey: '4ed85d9d-a1a7-49f8-a54e-ae2fbde8d88f',
            clientSource: '2',
            formTplId: 361,
            id: 598209,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_mod/edit/?4ed85d9d-a1a7-49f8-a54e-ae2fbde8d88f',
            invoicePaymentStatus: 2,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_mod/?4ed85d9d-a1a7-49f8-a54e-ae2fbde8d88f',
          },
        ],
        orderItemTotal: 37467.62,
        invoiceData: null,
        departureDate: '2022-04-12T00:00:00',
        assignedOperator: 2040155,
        total: '37467.62',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"Citation Ultra","tailNumber":"CITATION ULTRA","pax":3,"yom":1998,"safety_rating":{"argusSafety":null,"wyvernSafety":null},"price":34853.6,"taxes":{"fetTax":2614.02},"amount":null,"src":"redwing","operator":{"id":"b54f7620-3436-419f-a3ff-c43cd1f3d82f","name":"RED WING AEROPLANE COMPANY"},"reqLegData":[{"from":{"city":"Ft Lauderdale","country":"United States","iata":"FLL","icao":"KFLL","lon":-80.1527414,"lat":26.0725961,"name":"Hollywood Intl","tz":-14400000,"tzn":"America/New_York"},"to":{"city":"Denver","country":"United States","iata":"DEN","icao":"KDEN","lon":-104.6731667,"lat":39.8616667,"name":"Denver Intl","tz":-21600000,"tzn":"America/Denver"},"date":"2022-04-12T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":17397.5,"unitQuantity":1,"unitPercentage":null,"amount":17397.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":17397.5,"unitQuantity":null,"unitPercentage":7.5,"amount":1304.81,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.5,"unitPercentage":null},"unitBasePrice":4.5,"unitQuantity":7,"unitPercentage":null,"amount":31.5,"currency":"USD"}],"eft":3},{"from":{"city":"Denver","country":"United States","iata":"DEN","icao":"KDEN","lon":-104.6731667,"lat":39.8616667,"name":"Denver Intl","tz":-21600000,"tzn":"America/Denver"},"to":{"city":"Ft Lauderdale","country":"United States","iata":"FLL","icao":"KFLL","lon":-80.1527414,"lat":26.0725961,"name":"Hollywood Intl","tz":-14400000,"tzn":"America/New_York"},"date":"2022-03-27T16:10:09.000Z","time":16,"pax":3,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":17397.5,"unitQuantity":1,"unitPercentage":null,"amount":17397.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":17397.5,"unitQuantity":null,"unitPercentage":7.5,"amount":1304.81,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.5,"unitPercentage":null},"unitBasePrice":4.5,"unitQuantity":7,"unitPercentage":null,"amount":31.5,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KFLL","destination":"KDEN","departing":"2022-04-12T04:00:00.000Z","departingLocal":"2022-04-12T00:00:00.000Z","arrivingLocal":"2022-04-12T01:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KDEN","destination":"KFLL","departing":"2022-03-27T22:10:09.000Z","departingLocal":"2022-03-27T16:10:09.000Z","arrivingLocal":"2022-03-27T21:10:09.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":34853.6,"nonMemberPrice":34853.6,"original_price":34853.6,"sFtime":"0:06","origRequest":{"legFwd":430016,"legIDs":[430016,430017],"legRet":430017}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KFLL.KDEN.22.04.12.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '1829b7d8-0742-41cc-83c1-46a00a5ed349',
        requestId: 12789727,
        invoiceState: null,
        searchParams:
          '{"seg":["KFLL.KDEN.22.04.12.00.00","KDEN.KFLL.22.03.27.16.10"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: 'df6ba53a-f310-44ee-80f8-029213e62ea6',
        requestUrl: 'https://console.vista.studio/#fl:12789727',
        requestTime: '2022-03-23T13:09:02.411780+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 6,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2022-04-12T04:00:00+00:00',
      clientId: 1705839,
      requestId: 12789731,
    },
    {
      status: 103,
      legUrl: 'https://console.vista.studio/#activelegsfull:430017',
      flightRequestUrl: 'https://console.vista.studio/#fl:12789727',
      requestUrl: 'https://console.vista.studio/#l:12789732',
      flightRequestId: 12789727,
      legId: 430017,
      cateringCredit: {
        cateringCreditId: null,
        flightRequestId: 12789727,
        clientId: 1705839,
        amount: 250,
        legId: 430017,
        legRequestId: 12789732,
      },
      flightRequest: {
        status: 101,
        updateTime: '2022-03-23T13:15:23.701609+00:00',
        processorReply: null,
        achData: null,
        invoices: [
          {
            totalPrice: 37467.62,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/29161',
            createTime: '2022-03-23T13:09:10.195778+00:00',
            formUrlKey: 'b8da81eb-d998-4890-a823-ea4539a74406',
            clientSource: '2',
            formTplId: 359,
            id: 598205,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs/edit/?b8da81eb-d998-4890-a823-ea4539a74406',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs/?b8da81eb-d998-4890-a823-ea4539a74406',
          },
          {
            totalPrice: 37467.62,
            orderPaymentStatus: 5,
            orderUrl: 'http://localhost:3000/sales/orders/29164',
            createTime: '2022-03-23T13:22:26.182877+00:00',
            formUrlKey: 'fe532126-76e9-4de4-b1ed-26b04b67fae3',
            clientSource: '2',
            formTplId: 362,
            id: 598208,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?fe532126-76e9-4de4-b1ed-26b04b67fae3',
            invoicePaymentStatus: 4,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_add_terms/?fe532126-76e9-4de4-b1ed-26b04b67fae3',
          },
          {
            totalPrice: 37467.62,
            orderPaymentStatus: -1,
            createTime: '2022-03-23T13:26:06.124395+00:00',
            formUrlKey: '4ed85d9d-a1a7-49f8-a54e-ae2fbde8d88f',
            clientSource: '2',
            formTplId: 361,
            id: 598209,
            formEditUrl:
              'https://console.vista.studio/forms/xcharterjs_mod/edit/?4ed85d9d-a1a7-49f8-a54e-ae2fbde8d88f',
            invoicePaymentStatus: 2,
            formUrl:
              'https://console.vista.studio/forms/xcharterjs_mod/?4ed85d9d-a1a7-49f8-a54e-ae2fbde8d88f',
          },
        ],
        orderItemTotal: 37467.62,
        invoiceData: null,
        departureDate: '2022-04-12T00:00:00',
        assignedOperator: 2040155,
        total: '37467.62',
        requestText:
          '{"ftime":6,"ftime_seg_max":3,"img":[],"title":"Citation Ultra","tailNumber":"CITATION ULTRA","pax":3,"yom":1998,"safety_rating":{"argusSafety":null,"wyvernSafety":null},"price":34853.6,"taxes":{"fetTax":2614.02},"amount":null,"src":"redwing","operator":{"id":"b54f7620-3436-419f-a3ff-c43cd1f3d82f","name":"RED WING AEROPLANE COMPANY"},"reqLegData":[{"from":{"city":"Ft Lauderdale","country":"United States","iata":"FLL","icao":"KFLL","lon":-80.1527414,"lat":26.0725961,"name":"Hollywood Intl","tz":-14400000,"tzn":"America/New_York"},"to":{"city":"Denver","country":"United States","iata":"DEN","icao":"KDEN","lon":-104.6731667,"lat":39.8616667,"name":"Denver Intl","tz":-21600000,"tzn":"America/Denver"},"date":"2022-04-12T00:00:00.000Z","time":0,"pax":2,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":17397.5,"unitQuantity":1,"unitPercentage":null,"amount":17397.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":17397.5,"unitQuantity":null,"unitPercentage":7.5,"amount":1304.81,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.5,"unitPercentage":null},"unitBasePrice":4.5,"unitQuantity":7,"unitPercentage":null,"amount":31.5,"currency":"USD"}],"eft":3},{"from":{"city":"Denver","country":"United States","iata":"DEN","icao":"KDEN","lon":-104.6731667,"lat":39.8616667,"name":"Denver Intl","tz":-21600000,"tzn":"America/Denver"},"to":{"city":"Ft Lauderdale","country":"United States","iata":"FLL","icao":"KFLL","lon":-80.1527414,"lat":26.0725961,"name":"Hollywood Intl","tz":-14400000,"tzn":"America/New_York"},"date":"2022-03-27T16:10:09.000Z","time":16,"pax":3,"chargeComponents":[{"priceComponent":{"priceComponentId":"5e120f80-54d2-4b13-be3c-0232c694c865","name":"Flight Charge","unitBasePrice":null,"unitPercentage":null},"unitBasePrice":17397.5,"unitQuantity":1,"unitPercentage":null,"amount":17397.5,"currency":"USD"},{"priceComponent":{"priceComponentId":"ec3d446e-1b6e-4227-ad7e-55f8c016523d","name":"Tax","unitBasePrice":null,"unitPercentage":7.5},"unitBasePrice":17397.5,"unitQuantity":null,"unitPercentage":7.5,"amount":1304.81,"currency":"USD"},{"priceComponent":{"priceComponentId":"4044ae1a-4e27-4219-9e49-d7509a24eb05","name":"Segment Fee","unitBasePrice":4.5,"unitPercentage":null},"unitBasePrice":4.5,"unitQuantity":7,"unitPercentage":null,"amount":31.5,"currency":"USD"}],"eft":3}],"itinerary":[{"origin":"KFLL","destination":"KDEN","departing":"2022-04-12T04:00:00.000Z","departingLocal":"2022-04-12T00:00:00.000Z","arrivingLocal":"2022-04-12T01:00:00.000Z","flightTimeMinutes":180,"estimatedFuelStops":0},{"origin":"KDEN","destination":"KFLL","departing":"2022-03-27T22:10:09.000Z","departingLocal":"2022-03-27T16:10:09.000Z","arrivingLocal":"2022-03-27T21:10:09.000Z","flightTimeMinutes":180,"estimatedFuelStops":0}],"apiRequest":true,"img2":{},"memberPrice":34853.6,"nonMemberPrice":34853.6,"original_price":34853.6,"sFtime":"0:06","origRequest":{"legFwd":430016,"legIDs":[430016,430017],"legRet":430017}}',
        appExtra: null,
        cardTransactionId: null,
        comments: null,
        searchParamsSeqment: 'KFLL.KDEN.22.04.12.00.00',
        state: 0,
        production: false,
        pricingException: null,
        jetstudioSalesQuoteId: '1829b7d8-0742-41cc-83c1-46a00a5ed349',
        requestId: 12789727,
        invoiceState: null,
        searchParams:
          '{"seg":["KFLL.KDEN.22.04.12.00.00","KDEN.KFLL.22.03.27.16.10"],"pax":2,"fuelStops":0,"currency":"USD","version":"APP6"}',
        recepientId: null,
        jetstudioOpportunityId: 'df6ba53a-f310-44ee-80f8-029213e62ea6',
        requestUrl: 'https://console.vista.studio/#fl:12789727',
        requestTime: '2022-03-23T13:09:02.411780+00:00',
        isValid: true,
        requestTypeId: 1,
        charterAction: 6,
        requestedByClient: 1705839,
        clientId: 1705839,
        remoteIp: null,
      },
      departureDate: '2022-03-27T22:10:09+00:00',
      clientId: 1705839,
      requestId: 12789732,
    },
  ],
  flightRequests: [
    {
      invoices: [
        {
          totalPrice: 18929.68,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/25269',
          createTime: '2021-10-14T12:52:59.765125+00:00',
          formUrlKey: '9498c9a5-5200-4559-938a-dedda689a93d',
          clientSource: '2',
          formTplId: 359,
          id: 591993,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?9498c9a5-5200-4559-938a-dedda689a93d',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?9498c9a5-5200-4559-938a-dedda689a93d',
        },
      ],
      lastOrder: {
        orderItems: [
          {
            vendorId: 16,
            totalPrice: '100',
            orderItemTypeId: 9,
            orderStatusId: 6,
            productTypeId: 63,
            clientComments: null,
            legacyFormTplId: 353,
            id: 36237,
            markupPercent: '10',
            comments: null,
            serviceDiscountAmount: '10900',
            cateringCredit: null,
            requestId: 12771648,
            serviceDate: null,
            productId: 191,
            orderId: 29217,
            product: {
              productTypeId: 63,
              productId: 191,
              productName: 'XO Cleaning Fee',
            },
            flightRequestId: 12771647,
            productName: 'XO Cleaning Fee',
            beneficiaryPersonId: 1705839,
            vendorRefNumber: '123456',
            orderItemId: 36237,
            quoteAmount: '10000',
            basePrice: '11000.0',
          },
          {
            vendorId: 7,
            totalPrice: '4.4',
            orderItemTypeId: 9,
            orderStatusId: 6,
            productTypeId: 63,
            clientComments: '234',
            legacyFormTplId: 353,
            id: 36238,
            markupPercent: '10',
            comments: '234',
            serviceDiscountAmount: '3',
            cateringCredit: '250.0',
            requestId: 12771648,
            serviceDate: null,
            productId: 173,
            orderId: 29217,
            product: {
              productTypeId: 63,
              productId: 173,
              productName: 'XO Catering',
            },
            flightRequestId: 12771647,
            productName: 'XO Catering',
            beneficiaryPersonId: 1705839,
            vendorRefNumber: '234524',
            orderItemId: 36238,
            quoteAmount: '234',
            basePrice: '257.4',
          },
        ],
      },
      conciergeAction: 2,
      departureDate: '2021-10-26T07:00:00+00:00',
      requestId: 12771647,
    },
    {
      invoices: [
        {
          totalPrice: 18929.68,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/25269',
          createTime: '2021-10-14T12:52:59.765125+00:00',
          formUrlKey: '9498c9a5-5200-4559-938a-dedda689a93d',
          clientSource: '2',
          formTplId: 359,
          id: 591993,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?9498c9a5-5200-4559-938a-dedda689a93d',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?9498c9a5-5200-4559-938a-dedda689a93d',
        },
      ],
      lastOrder: {
        orderItems: [
          {
            vendorId: 16,
            totalPrice: '100',
            orderItemTypeId: 9,
            orderStatusId: 6,
            productTypeId: 63,
            clientComments: null,
            legacyFormTplId: 353,
            id: 36237,
            markupPercent: '10',
            comments: null,
            serviceDiscountAmount: '10900',
            cateringCredit: null,
            requestId: 12771648,
            serviceDate: null,
            productId: 191,
            orderId: 29217,
            product: {
              productTypeId: 63,
              productId: 191,
              productName: 'XO Cleaning Fee',
            },
            flightRequestId: 12771647,
            productName: 'XO Cleaning Fee',
            beneficiaryPersonId: 1705839,
            vendorRefNumber: '123456',
            orderItemId: 36237,
            quoteAmount: '10000',
            basePrice: '11000.0',
          },
          {
            vendorId: 7,
            totalPrice: '4.4',
            orderItemTypeId: 9,
            orderStatusId: 6,
            productTypeId: 63,
            clientComments: '234',
            legacyFormTplId: 353,
            id: 36238,
            markupPercent: '10',
            comments: '234',
            serviceDiscountAmount: '3',
            cateringCredit: '250.0',
            requestId: 12771648,
            serviceDate: null,
            productId: 173,
            orderId: 29217,
            product: {
              productTypeId: 63,
              productId: 173,
              productName: 'XO Catering',
            },
            flightRequestId: 12771647,
            productName: 'XO Catering',
            beneficiaryPersonId: 1705839,
            vendorRefNumber: '234524',
            orderItemId: 36238,
            quoteAmount: '234',
            basePrice: '257.4',
          },
        ],
      },
      conciergeAction: 2,
      departureDate: '2021-10-28T07:00:00+00:00',
      requestId: 12771647,
    },
    {
      invoices: [
        {
          totalPrice: 18929.68,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/25273',
          createTime: '2021-10-14T19:08:32.322799+00:00',
          formUrlKey: '07d39b6e-fb73-472c-8fa8-2da8d0548332',
          clientSource: '2',
          formTplId: 359,
          id: 592021,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?07d39b6e-fb73-472c-8fa8-2da8d0548332',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?07d39b6e-fb73-472c-8fa8-2da8d0548332',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2021-10-26T07:00:00+00:00',
      requestId: 12771709,
    },
    {
      invoices: [
        {
          totalPrice: 18929.68,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/25273',
          createTime: '2021-10-14T19:08:32.322799+00:00',
          formUrlKey: '07d39b6e-fb73-472c-8fa8-2da8d0548332',
          clientSource: '2',
          formTplId: 359,
          id: 592021,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?07d39b6e-fb73-472c-8fa8-2da8d0548332',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?07d39b6e-fb73-472c-8fa8-2da8d0548332',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2021-10-28T07:00:00+00:00',
      requestId: 12771709,
    },
    {
      invoices: [
        {
          totalPrice: 18929.68,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/25280',
          createTime: '2021-10-15T13:10:53.134531+00:00',
          formUrlKey: '63267ef8-fa32-4c14-8b3a-2771115ac3d1',
          clientSource: '2',
          formTplId: 359,
          id: 592077,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?63267ef8-fa32-4c14-8b3a-2771115ac3d1',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?63267ef8-fa32-4c14-8b3a-2771115ac3d1',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2021-10-26T07:00:00+00:00',
      requestId: 12771894,
    },
    {
      invoices: [
        {
          totalPrice: 18929.68,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/25280',
          createTime: '2021-10-15T13:10:53.134531+00:00',
          formUrlKey: '63267ef8-fa32-4c14-8b3a-2771115ac3d1',
          clientSource: '2',
          formTplId: 359,
          id: 592077,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?63267ef8-fa32-4c14-8b3a-2771115ac3d1',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?63267ef8-fa32-4c14-8b3a-2771115ac3d1',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2021-10-28T07:00:00+00:00',
      requestId: 12771894,
    },
    {
      invoices: [
        {
          totalPrice: 18929.68,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/25284',
          createTime: '2021-10-15T14:04:20.030445+00:00',
          formUrlKey: 'bb80f6a5-7485-4555-923e-f95d1b036e6e',
          clientSource: '2',
          formTplId: 359,
          id: 592083,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?bb80f6a5-7485-4555-923e-f95d1b036e6e',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?bb80f6a5-7485-4555-923e-f95d1b036e6e',
        },
        {
          totalPrice: 18929.68,
          orderPaymentStatus: 6,
          orderUrl: 'http://localhost:3000/sales/orders/29175',
          createTime: '2022-03-23T13:57:50.757660+00:00',
          formUrlKey: '1fa8ed22-2f32-42f9-b8f2-624ad8a207a8',
          clientSource: '2',
          formTplId: 362,
          id: 598220,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?1fa8ed22-2f32-42f9-b8f2-624ad8a207a8',
          invoicePaymentStatus: 2,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/?1fa8ed22-2f32-42f9-b8f2-624ad8a207a8',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2021-10-26T07:00:00+00:00',
      requestId: 12771921,
    },
    {
      invoices: [
        {
          totalPrice: 18929.68,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/25284',
          createTime: '2021-10-15T14:04:20.030445+00:00',
          formUrlKey: 'bb80f6a5-7485-4555-923e-f95d1b036e6e',
          clientSource: '2',
          formTplId: 359,
          id: 592083,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?bb80f6a5-7485-4555-923e-f95d1b036e6e',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?bb80f6a5-7485-4555-923e-f95d1b036e6e',
        },
        {
          totalPrice: 18929.68,
          orderPaymentStatus: 6,
          orderUrl: 'http://localhost:3000/sales/orders/29175',
          createTime: '2022-03-23T13:57:50.757660+00:00',
          formUrlKey: '1fa8ed22-2f32-42f9-b8f2-624ad8a207a8',
          clientSource: '2',
          formTplId: 362,
          id: 598220,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?1fa8ed22-2f32-42f9-b8f2-624ad8a207a8',
          invoicePaymentStatus: 2,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/?1fa8ed22-2f32-42f9-b8f2-624ad8a207a8',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2021-10-28T07:00:00+00:00',
      requestId: 12771921,
    },
    {
      invoices: [
        {
          totalPrice: 13518.12,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/25360',
          createTime: '2021-10-21T04:32:33.211428+00:00',
          formUrlKey: 'eebe2ec0-e42a-427c-b7b1-e6b6cf1f4787',
          clientSource: '2',
          formTplId: 359,
          id: 592267,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?eebe2ec0-e42a-427c-b7b1-e6b6cf1f4787',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?eebe2ec0-e42a-427c-b7b1-e6b6cf1f4787',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2021-11-10T08:00:00+00:00',
      requestId: 12772332,
    },
    {
      invoices: [
        {
          totalPrice: 13518.12,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/25360',
          createTime: '2021-10-21T04:32:33.211428+00:00',
          formUrlKey: 'eebe2ec0-e42a-427c-b7b1-e6b6cf1f4787',
          clientSource: '2',
          formTplId: 359,
          id: 592267,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?eebe2ec0-e42a-427c-b7b1-e6b6cf1f4787',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?eebe2ec0-e42a-427c-b7b1-e6b6cf1f4787',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2021-11-12T08:00:00+00:00',
      requestId: 12772332,
    },
    {
      invoices: [
        {
          totalPrice: 12765.62,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/25402',
          createTime: '2021-10-27T18:31:25.613744+00:00',
          formUrlKey: 'c5256d08-4bb7-4d32-b428-3d33c0170892',
          clientSource: '2',
          formTplId: 359,
          id: 592389,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?c5256d08-4bb7-4d32-b428-3d33c0170892',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?c5256d08-4bb7-4d32-b428-3d33c0170892',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2021-11-10T08:00:00+00:00',
      requestId: 12772723,
    },
    {
      invoices: [
        {
          totalPrice: 12765.62,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/25402',
          createTime: '2021-10-27T18:31:25.613744+00:00',
          formUrlKey: 'c5256d08-4bb7-4d32-b428-3d33c0170892',
          clientSource: '2',
          formTplId: 359,
          id: 592389,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?c5256d08-4bb7-4d32-b428-3d33c0170892',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?c5256d08-4bb7-4d32-b428-3d33c0170892',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2021-11-12T08:00:00+00:00',
      requestId: 12772723,
    },
    {
      invoices: [
        {
          totalPrice: 12765.62,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/25406',
          createTime: '2021-10-28T04:02:17.752680+00:00',
          formUrlKey: '91ade0e5-2f71-4940-a87a-f91a98bb3273',
          clientSource: '2',
          formTplId: 359,
          id: 592406,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?91ade0e5-2f71-4940-a87a-f91a98bb3273',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?91ade0e5-2f71-4940-a87a-f91a98bb3273',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2021-11-10T08:00:00+00:00',
      requestId: 12772747,
    },
    {
      invoices: [
        {
          totalPrice: 12765.62,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/25406',
          createTime: '2021-10-28T04:02:17.752680+00:00',
          formUrlKey: '91ade0e5-2f71-4940-a87a-f91a98bb3273',
          clientSource: '2',
          formTplId: 359,
          id: 592406,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?91ade0e5-2f71-4940-a87a-f91a98bb3273',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?91ade0e5-2f71-4940-a87a-f91a98bb3273',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2021-11-12T08:00:00+00:00',
      requestId: 12772747,
    },
    {
      invoices: [
        {
          totalPrice: 12765.62,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/25405',
          createTime: '2021-10-28T04:01:53.566083+00:00',
          formUrlKey: 'f588cfb5-cd48-4907-ba42-76a11fc8affe',
          clientSource: '2',
          formTplId: 359,
          id: 592404,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?f588cfb5-cd48-4907-ba42-76a11fc8affe',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?f588cfb5-cd48-4907-ba42-76a11fc8affe',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2021-11-10T08:00:00+00:00',
      requestId: 12772746,
    },
    {
      invoices: [
        {
          totalPrice: 12765.62,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/25405',
          createTime: '2021-10-28T04:01:53.566083+00:00',
          formUrlKey: 'f588cfb5-cd48-4907-ba42-76a11fc8affe',
          clientSource: '2',
          formTplId: 359,
          id: 592404,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?f588cfb5-cd48-4907-ba42-76a11fc8affe',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?f588cfb5-cd48-4907-ba42-76a11fc8affe',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2021-11-12T08:00:00+00:00',
      requestId: 12772746,
    },
    {
      invoices: [
        {
          totalPrice: 13303.12,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/25403',
          createTime: '2021-10-27T18:31:52.630093+00:00',
          formUrlKey: '770be65e-6254-4a89-b7e4-5c0457b1adfd',
          clientSource: '2',
          formTplId: 359,
          id: 592391,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?770be65e-6254-4a89-b7e4-5c0457b1adfd',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?770be65e-6254-4a89-b7e4-5c0457b1adfd',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2021-11-10T08:00:00+00:00',
      requestId: 12772724,
    },
    {
      invoices: [
        {
          totalPrice: 13303.12,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/25403',
          createTime: '2021-10-27T18:31:52.630093+00:00',
          formUrlKey: '770be65e-6254-4a89-b7e4-5c0457b1adfd',
          clientSource: '2',
          formTplId: 359,
          id: 592391,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?770be65e-6254-4a89-b7e4-5c0457b1adfd',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?770be65e-6254-4a89-b7e4-5c0457b1adfd',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2021-11-12T08:00:00+00:00',
      requestId: 12772724,
    },
    {
      invoices: [
        {
          totalPrice: 13088.12,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/25357',
          createTime: '2021-10-21T04:31:48.619127+00:00',
          formUrlKey: '1a3aa657-a9f4-43c8-b37c-43d7408f6724',
          clientSource: '2',
          formTplId: 359,
          id: 592261,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?1a3aa657-a9f4-43c8-b37c-43d7408f6724',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?1a3aa657-a9f4-43c8-b37c-43d7408f6724',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2021-11-10T08:00:00+00:00',
      requestId: 12772329,
    },
    {
      invoices: [
        {
          totalPrice: 13088.12,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/25357',
          createTime: '2021-10-21T04:31:48.619127+00:00',
          formUrlKey: '1a3aa657-a9f4-43c8-b37c-43d7408f6724',
          clientSource: '2',
          formTplId: 359,
          id: 592261,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?1a3aa657-a9f4-43c8-b37c-43d7408f6724',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?1a3aa657-a9f4-43c8-b37c-43d7408f6724',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2021-11-12T08:00:00+00:00',
      requestId: 12772329,
    },
    {
      invoices: [
        {
          totalPrice: 12765.62,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/25458',
          createTime: '2021-10-30T21:15:58.677226+00:00',
          formUrlKey: '820eb23f-718a-494e-9462-29328e0c2458',
          clientSource: '2',
          formTplId: 359,
          id: 592465,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?820eb23f-718a-494e-9462-29328e0c2458',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?820eb23f-718a-494e-9462-29328e0c2458',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2021-11-10T08:00:00+00:00',
      requestId: 12772922,
    },
    {
      invoices: [
        {
          totalPrice: 12765.62,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/25458',
          createTime: '2021-10-30T21:15:58.677226+00:00',
          formUrlKey: '820eb23f-718a-494e-9462-29328e0c2458',
          clientSource: '2',
          formTplId: 359,
          id: 592465,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?820eb23f-718a-494e-9462-29328e0c2458',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?820eb23f-718a-494e-9462-29328e0c2458',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2021-11-12T08:00:00+00:00',
      requestId: 12772922,
    },
    {
      invoices: [],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2022-01-10T05:00:00+00:00',
      requestId: 12778547,
    },
    {
      invoices: [
        {
          totalPrice: 0,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/26550',
          createTime: '2021-12-30T23:47:20.859769+00:00',
          formUrlKey: 'd390313a-fef4-4d4f-b688-0a86c3ecbd67',
          clientSource: '2',
          formTplId: 359,
          id: 594835,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?d390313a-fef4-4d4f-b688-0a86c3ecbd67',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?d390313a-fef4-4d4f-b688-0a86c3ecbd67',
        },
        {
          totalPrice: 0,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/26551',
          createTime: '2021-12-31T00:08:59.089777+00:00',
          formUrlKey: '3c65bacc-89eb-40e7-8951-8484aa430cd7',
          clientSource: '2',
          formTplId: 362,
          id: 594837,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?3c65bacc-89eb-40e7-8951-8484aa430cd7',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/?3c65bacc-89eb-40e7-8951-8484aa430cd7',
        },
        {
          totalPrice: 0,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/26552',
          createTime: '2021-12-31T00:14:16.877673+00:00',
          formUrlKey: 'd6aaab36-270d-4539-b715-a848ee1d4c78',
          clientSource: '2',
          formTplId: 360,
          id: 594839,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add/edit/?d6aaab36-270d-4539-b715-a848ee1d4c78',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add/?d6aaab36-270d-4539-b715-a848ee1d4c78',
        },
        {
          totalPrice: 25410,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/26553',
          createTime: '2021-12-31T00:21:44.598204+00:00',
          formUrlKey: '8938258a-a2e9-459e-99f3-7c1d343e4f14',
          clientSource: '2',
          formTplId: 362,
          id: 594842,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?8938258a-a2e9-459e-99f3-7c1d343e4f14',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/?8938258a-a2e9-459e-99f3-7c1d343e4f14',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2022-01-10T05:00:00+00:00',
      requestId: 12778549,
    },
    {
      invoices: [
        {
          totalPrice: 25085.13,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/26554',
          createTime: '2021-12-31T00:29:24.312054+00:00',
          formUrlKey: '786128c6-e7ca-4216-93fc-e7f32c9d867f',
          clientSource: '2',
          formTplId: 359,
          id: 594844,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?786128c6-e7ca-4216-93fc-e7f32c9d867f',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?786128c6-e7ca-4216-93fc-e7f32c9d867f',
        },
        {
          totalPrice: 21543,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/26555',
          createTime: '2021-12-31T00:34:42.908196+00:00',
          formUrlKey: '3411009a-21e4-41e8-8157-b59f001bc850',
          clientSource: '2',
          formTplId: 362,
          id: 594846,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?3411009a-21e4-41e8-8157-b59f001bc850',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/?3411009a-21e4-41e8-8157-b59f001bc850',
        },
        {
          totalPrice: 5375,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/26556',
          createTime: '2021-12-31T00:36:54.548863+00:00',
          formUrlKey: '081f4ad7-95f1-4c2f-8577-0fbf1e20c8ba',
          clientSource: '2',
          formTplId: 360,
          id: 594848,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add/edit/?081f4ad7-95f1-4c2f-8577-0fbf1e20c8ba',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add/?081f4ad7-95f1-4c2f-8577-0fbf1e20c8ba',
        },
        {
          totalPrice: 1075,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/26557',
          createTime: '2021-12-31T00:42:11.966612+00:00',
          formUrlKey: 'a7178993-e070-4aa3-8a76-fb71160bba21',
          clientSource: '2',
          formTplId: 360,
          id: 594850,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add/edit/?a7178993-e070-4aa3-8a76-fb71160bba21',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add/?a7178993-e070-4aa3-8a76-fb71160bba21',
        },
        {
          totalPrice: 1075,
          orderPaymentStatus: -1,
          createTime: '2022-01-05T20:17:26.597843+00:00',
          formUrlKey: 'feabc2a6-f7c8-4498-ab2c-7caab389eed0',
          clientSource: '2',
          formTplId: 361,
          id: 594889,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_mod/edit/?feabc2a6-f7c8-4498-ab2c-7caab389eed0',
          invoicePaymentStatus: 2,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_mod/?feabc2a6-f7c8-4498-ab2c-7caab389eed0',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2022-01-10T05:00:00+00:00',
      requestId: 12778551,
    },
    {
      invoices: [
        {
          totalPrice: 0,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/26561',
          createTime: '2022-01-05T18:39:15.332522+00:00',
          formUrlKey: '15135f70-5f06-46ea-a938-91bd07dbb224',
          clientSource: '2',
          formTplId: 359,
          id: 594875,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?15135f70-5f06-46ea-a938-91bd07dbb224',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?15135f70-5f06-46ea-a938-91bd07dbb224',
        },
        {
          totalPrice: 0,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/26562',
          createTime: '2022-01-05T18:47:16.991269+00:00',
          formUrlKey: '87f1cb77-7efd-41b1-af9c-7af7f922e439',
          clientSource: '2',
          formTplId: 362,
          id: 594877,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?87f1cb77-7efd-41b1-af9c-7af7f922e439',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/?87f1cb77-7efd-41b1-af9c-7af7f922e439',
        },
        {
          totalPrice: 0,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/26563',
          createTime: '2022-01-05T18:50:57.084096+00:00',
          formUrlKey: '7f95e6cb-d7e1-4149-a837-adffa81c4e56',
          clientSource: '2',
          formTplId: 360,
          id: 594879,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add/edit/?7f95e6cb-d7e1-4149-a837-adffa81c4e56',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add/?7f95e6cb-d7e1-4149-a837-adffa81c4e56',
        },
        {
          totalPrice: 11000,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/26564',
          createTime: '2022-01-05T18:56:28.391012+00:00',
          formUrlKey: '5f6fd29b-e7d2-4331-8a49-0d5c83785e0d',
          clientSource: '2',
          formTplId: 362,
          id: 594881,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?5f6fd29b-e7d2-4331-8a49-0d5c83785e0d',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/?5f6fd29b-e7d2-4331-8a49-0d5c83785e0d',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2022-01-10T05:00:00+00:00',
      requestId: 12778635,
    },
    {
      invoices: [
        {
          totalPrice: 0,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/26565',
          createTime: '2022-01-05T19:57:50.473223+00:00',
          formUrlKey: 'cfb29fc6-f838-46e5-980c-a4484892b158',
          clientSource: '2',
          formTplId: 359,
          id: 594883,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?cfb29fc6-f838-46e5-980c-a4484892b158',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?cfb29fc6-f838-46e5-980c-a4484892b158',
        },
        {
          totalPrice: 0,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/26566',
          createTime: '2022-01-05T20:05:42.890346+00:00',
          formUrlKey: 'a7be4177-f94b-4bf8-9666-0c2b7e1023fb',
          clientSource: '2',
          formTplId: 362,
          id: 594885,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?a7be4177-f94b-4bf8-9666-0c2b7e1023fb',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/?a7be4177-f94b-4bf8-9666-0c2b7e1023fb',
        },
        {
          totalPrice: 0,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/26567',
          createTime: '2022-01-05T20:08:01.419503+00:00',
          formUrlKey: '81455ffb-6663-4902-8200-43361dbc0577',
          clientSource: '2',
          formTplId: 360,
          id: 594887,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add/edit/?81455ffb-6663-4902-8200-43361dbc0577',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add/?81455ffb-6663-4902-8200-43361dbc0577',
        },
        {
          totalPrice: 11000,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/26568',
          createTime: '2022-01-05T20:23:50.242930+00:00',
          formUrlKey: '07b34d58-6168-47b5-ba47-5911dad448dc',
          clientSource: '2',
          formTplId: 362,
          id: 594891,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?07b34d58-6168-47b5-ba47-5911dad448dc',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/?07b34d58-6168-47b5-ba47-5911dad448dc',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2022-01-10T05:00:00+00:00',
      requestId: 12778639,
    },
    {
      invoices: [
        {
          totalPrice: 0,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/26569',
          createTime: '2022-01-05T21:05:11.949876+00:00',
          formUrlKey: '48e57d17-3dd8-4cb7-a9c6-ebc4aff098a5',
          clientSource: '2',
          formTplId: 359,
          id: 594893,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?48e57d17-3dd8-4cb7-a9c6-ebc4aff098a5',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?48e57d17-3dd8-4cb7-a9c6-ebc4aff098a5',
        },
        {
          totalPrice: 0,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/26570',
          createTime: '2022-01-05T21:11:30.941327+00:00',
          formUrlKey: 'b5e072f5-d6a4-401f-8147-29236850676e',
          clientSource: '2',
          formTplId: 362,
          id: 594895,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?b5e072f5-d6a4-401f-8147-29236850676e',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/?b5e072f5-d6a4-401f-8147-29236850676e',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2022-01-10T05:00:00+00:00',
      requestId: 12778653,
    },
    {
      invoices: [
        {
          totalPrice: 0,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/26577',
          createTime: '2022-01-06T20:58:59.528549+00:00',
          formUrlKey: '70406085-c0a6-4f04-ae36-65ca0d91539f',
          clientSource: '2',
          formTplId: 359,
          id: 594930,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?70406085-c0a6-4f04-ae36-65ca0d91539f',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?70406085-c0a6-4f04-ae36-65ca0d91539f',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2022-01-10T05:00:00+00:00',
      requestId: 12778740,
    },
    {
      invoices: [
        {
          totalPrice: 0,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/26628',
          createTime: '2022-01-10T22:18:31.384704+00:00',
          formUrlKey: '9c1ccce6-4eb4-44f9-92df-27592ef864b8',
          clientSource: '2',
          formTplId: 359,
          id: 595027,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?9c1ccce6-4eb4-44f9-92df-27592ef864b8',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?9c1ccce6-4eb4-44f9-92df-27592ef864b8',
        },
        {
          totalPrice: 0,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/26629',
          createTime: '2022-01-10T22:23:37.646670+00:00',
          formUrlKey: '54a7b210-7454-44ed-b7a4-93838a16f2ac',
          clientSource: '2',
          formTplId: 362,
          id: 595029,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?54a7b210-7454-44ed-b7a4-93838a16f2ac',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/?54a7b210-7454-44ed-b7a4-93838a16f2ac',
        },
        {
          totalPrice: 0,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/26630',
          createTime: '2022-01-10T22:33:54.393231+00:00',
          formUrlKey: '40ef395a-c91d-413a-b437-f4f2e0c0819c',
          clientSource: '2',
          formTplId: 360,
          id: 595031,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add/edit/?40ef395a-c91d-413a-b437-f4f2e0c0819c',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add/?40ef395a-c91d-413a-b437-f4f2e0c0819c',
        },
        {
          totalPrice: 13768.8,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/26631',
          createTime: '2022-01-10T22:41:49.231644+00:00',
          formUrlKey: 'b878f8c4-5a93-4e73-8647-ff48403cde92',
          clientSource: '2',
          formTplId: 362,
          id: 595033,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?b878f8c4-5a93-4e73-8647-ff48403cde92',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/?b878f8c4-5a93-4e73-8647-ff48403cde92',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2022-01-10T05:00:00+00:00',
      requestId: 12779014,
    },
    {
      invoices: [
        {
          totalPrice: 0,
          orderPaymentStatus: 7,
          orderUrl: 'http://localhost:3000/sales/orders/26889',
          createTime: '2022-01-24T20:55:55.447265+00:00',
          formUrlKey: '0434606c-9c19-4036-add3-0dcda3cacdd0',
          clientSource: '2',
          formTplId: 359,
          id: 595558,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?0434606c-9c19-4036-add3-0dcda3cacdd0',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?0434606c-9c19-4036-add3-0dcda3cacdd0',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2022-01-10T05:00:00+00:00',
      requestId: 12781299,
    },
    {
      invoices: [
        {
          totalPrice: 24761,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/28807',
          createTime: '2022-03-15T00:04:42.061104+00:00',
          formUrlKey: '811efa0a-6fd6-4d16-a27f-383b4e6032c0',
          clientSource: '2',
          formTplId: 359,
          id: 597613,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?811efa0a-6fd6-4d16-a27f-383b4e6032c0',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?811efa0a-6fd6-4d16-a27f-383b4e6032c0',
        },
        {
          totalPrice: 24000,
          orderPaymentStatus: 7,
          orderUrl: 'http://localhost:3000/sales/orders/28808',
          createTime: '2022-03-15T00:19:54.418363+00:00',
          formUrlKey: '14757875-7cc6-4969-99ff-d064db028046',
          clientSource: '2',
          formTplId: 362,
          id: 597615,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?14757875-7cc6-4969-99ff-d064db028046',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/?14757875-7cc6-4969-99ff-d064db028046',
        },
        {
          totalPrice: 1000,
          orderPaymentStatus: 6,
          orderUrl: 'http://localhost:3000/sales/orders/28810',
          createTime: '2022-03-15T01:06:22.320414+00:00',
          formUrlKey: 'b21a1c64-56cb-4148-9abb-ba7cb3015bfc',
          clientSource: '2',
          formTplId: 360,
          id: 597619,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add/edit/?b21a1c64-56cb-4148-9abb-ba7cb3015bfc',
          invoicePaymentStatus: 2,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add/?b21a1c64-56cb-4148-9abb-ba7cb3015bfc',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2022-04-12T04:00:00+00:00',
      requestId: 12788378,
    },
    {
      invoices: [
        {
          totalPrice: 37436.12,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/28936',
          createTime: '2022-03-17T04:10:45.124158+00:00',
          formUrlKey: '7ef70624-c5d7-4862-9b67-0e8803a62452',
          clientSource: '2',
          formTplId: 359,
          id: 597829,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?7ef70624-c5d7-4862-9b67-0e8803a62452',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?7ef70624-c5d7-4862-9b67-0e8803a62452',
        },
        {
          totalPrice: 37436.12,
          orderPaymentStatus: -1,
          createTime: '2022-03-17T16:21:21.542535+00:00',
          formUrlKey: '4ebee999-e97c-4dab-8e0f-3c71892a19de',
          clientSource: '2',
          formTplId: 361,
          id: 597925,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_mod/edit/?4ebee999-e97c-4dab-8e0f-3c71892a19de',
          invoicePaymentStatus: 2,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_mod/?4ebee999-e97c-4dab-8e0f-3c71892a19de',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2022-04-12T04:00:00+00:00',
      requestId: 12788808,
    },
    {
      invoices: [
        {
          totalPrice: 37436.12,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/28998',
          createTime: '2022-03-17T16:24:14.804929+00:00',
          formUrlKey: '0a2fd611-0584-41c9-a679-597e237835a3',
          clientSource: '2',
          formTplId: 359,
          id: 597928,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?0a2fd611-0584-41c9-a679-597e237835a3',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?0a2fd611-0584-41c9-a679-597e237835a3',
        },
        {
          totalPrice: 37436.12,
          orderPaymentStatus: -1,
          createTime: '2022-03-18T10:05:02.288264+00:00',
          formUrlKey: 'f9d30aa3-5d53-4af6-9b31-9bed9810713e',
          clientSource: '2',
          formTplId: 361,
          id: 597956,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_mod/edit/?f9d30aa3-5d53-4af6-9b31-9bed9810713e',
          invoicePaymentStatus: 2,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_mod/?f9d30aa3-5d53-4af6-9b31-9bed9810713e',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2022-04-12T04:00:00+00:00',
      requestId: 12789030,
    },
    {
      invoices: [
        {
          totalPrice: 37436.13,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/29020',
          createTime: '2022-03-18T12:08:12.978661+00:00',
          formUrlKey: '939e1773-ed03-42af-a3d4-4776556f59a6',
          clientSource: '2',
          formTplId: 359,
          id: 597979,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?939e1773-ed03-42af-a3d4-4776556f59a6',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?939e1773-ed03-42af-a3d4-4776556f59a6',
        },
        {
          totalPrice: 37436.13,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/29021',
          createTime: '2022-03-18T12:11:49.443990+00:00',
          formUrlKey: 'ad15a6b7-baec-473b-8c42-5ddb1842c271',
          clientSource: '2',
          formTplId: 362,
          id: 597981,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?ad15a6b7-baec-473b-8c42-5ddb1842c271',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/?ad15a6b7-baec-473b-8c42-5ddb1842c271',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2022-04-12T04:00:00+00:00',
      requestId: 12789232,
    },
    {
      invoices: [
        {
          totalPrice: 36211.44,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/29060',
          createTime: '2022-03-21T14:10:42.503609+00:00',
          formUrlKey: '1b65de8c-2774-4b15-8725-5d05e525db95',
          clientSource: '2',
          formTplId: 359,
          id: 598058,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?1b65de8c-2774-4b15-8725-5d05e525db95',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?1b65de8c-2774-4b15-8725-5d05e525db95',
        },
        {
          totalPrice: 36211.44,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/29061',
          createTime: '2022-03-21T14:19:57.592931+00:00',
          formUrlKey: '74adefb1-08f2-4ffa-b5d2-8c7f32c9cd81',
          clientSource: '2',
          formTplId: 362,
          id: 598060,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?74adefb1-08f2-4ffa-b5d2-8c7f32c9cd81',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/?74adefb1-08f2-4ffa-b5d2-8c7f32c9cd81',
        },
        {
          totalPrice: 36211.44,
          orderPaymentStatus: -1,
          createTime: '2022-03-21T14:23:12.967889+00:00',
          formUrlKey: '853d0ec9-bafd-47f7-b518-382e2112a6a9',
          clientSource: '2',
          formTplId: 361,
          id: 598062,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_mod/edit/?853d0ec9-bafd-47f7-b518-382e2112a6a9',
          invoicePaymentStatus: 2,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_mod/?853d0ec9-bafd-47f7-b518-382e2112a6a9',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2022-04-12T04:00:00+00:00',
      requestId: 12789485,
    },
    {
      invoices: [
        {
          totalPrice: 36211.44,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/29060',
          createTime: '2022-03-21T14:10:42.503609+00:00',
          formUrlKey: '1b65de8c-2774-4b15-8725-5d05e525db95',
          clientSource: '2',
          formTplId: 359,
          id: 598058,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?1b65de8c-2774-4b15-8725-5d05e525db95',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?1b65de8c-2774-4b15-8725-5d05e525db95',
        },
        {
          totalPrice: 36211.44,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/29061',
          createTime: '2022-03-21T14:19:57.592931+00:00',
          formUrlKey: '74adefb1-08f2-4ffa-b5d2-8c7f32c9cd81',
          clientSource: '2',
          formTplId: 362,
          id: 598060,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?74adefb1-08f2-4ffa-b5d2-8c7f32c9cd81',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/?74adefb1-08f2-4ffa-b5d2-8c7f32c9cd81',
        },
        {
          totalPrice: 36211.44,
          orderPaymentStatus: -1,
          createTime: '2022-03-21T14:23:12.967889+00:00',
          formUrlKey: '853d0ec9-bafd-47f7-b518-382e2112a6a9',
          clientSource: '2',
          formTplId: 361,
          id: 598062,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_mod/edit/?853d0ec9-bafd-47f7-b518-382e2112a6a9',
          invoicePaymentStatus: 2,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_mod/?853d0ec9-bafd-47f7-b518-382e2112a6a9',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2022-03-27T22:10:09+00:00',
      requestId: 12789485,
    },
    {
      invoices: [
        {
          totalPrice: 36131.31,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/29074',
          createTime: '2022-03-21T15:51:21.607402+00:00',
          formUrlKey: 'b31a49cb-96e0-4566-b113-0868ab3d8297',
          clientSource: '2',
          formTplId: 359,
          id: 598076,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?b31a49cb-96e0-4566-b113-0868ab3d8297',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?b31a49cb-96e0-4566-b113-0868ab3d8297',
        },
        {
          totalPrice: 36131.31,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/29076',
          createTime: '2022-03-21T15:58:02.676580+00:00',
          formUrlKey: '85e4cef3-0862-4381-a9a2-7c49891822ec',
          clientSource: '2',
          formTplId: 362,
          id: 598079,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?85e4cef3-0862-4381-a9a2-7c49891822ec',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/?85e4cef3-0862-4381-a9a2-7c49891822ec',
        },
        {
          totalPrice: 36131.31,
          orderPaymentStatus: -1,
          createTime: '2022-03-21T15:59:55.009597+00:00',
          formUrlKey: 'aadd32fb-0514-4d63-803c-f82e38839b5d',
          clientSource: '2',
          formTplId: 361,
          id: 598080,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_mod/edit/?aadd32fb-0514-4d63-803c-f82e38839b5d',
          invoicePaymentStatus: 2,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_mod/?aadd32fb-0514-4d63-803c-f82e38839b5d',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2022-04-12T04:00:00+00:00',
      requestId: 12789512,
    },
    {
      invoices: [
        {
          totalPrice: 36131.31,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/29074',
          createTime: '2022-03-21T15:51:21.607402+00:00',
          formUrlKey: 'b31a49cb-96e0-4566-b113-0868ab3d8297',
          clientSource: '2',
          formTplId: 359,
          id: 598076,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?b31a49cb-96e0-4566-b113-0868ab3d8297',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?b31a49cb-96e0-4566-b113-0868ab3d8297',
        },
        {
          totalPrice: 36131.31,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/29076',
          createTime: '2022-03-21T15:58:02.676580+00:00',
          formUrlKey: '85e4cef3-0862-4381-a9a2-7c49891822ec',
          clientSource: '2',
          formTplId: 362,
          id: 598079,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?85e4cef3-0862-4381-a9a2-7c49891822ec',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/?85e4cef3-0862-4381-a9a2-7c49891822ec',
        },
        {
          totalPrice: 36131.31,
          orderPaymentStatus: -1,
          createTime: '2022-03-21T15:59:55.009597+00:00',
          formUrlKey: 'aadd32fb-0514-4d63-803c-f82e38839b5d',
          clientSource: '2',
          formTplId: 361,
          id: 598080,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_mod/edit/?aadd32fb-0514-4d63-803c-f82e38839b5d',
          invoicePaymentStatus: 2,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_mod/?aadd32fb-0514-4d63-803c-f82e38839b5d',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2022-03-27T22:10:09+00:00',
      requestId: 12789512,
    },
    {
      invoices: [
        {
          totalPrice: 37467.62,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/29161',
          createTime: '2022-03-23T13:09:10.195778+00:00',
          formUrlKey: 'b8da81eb-d998-4890-a823-ea4539a74406',
          clientSource: '2',
          formTplId: 359,
          id: 598205,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?b8da81eb-d998-4890-a823-ea4539a74406',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?b8da81eb-d998-4890-a823-ea4539a74406',
        },
        {
          totalPrice: 37467.62,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/29164',
          createTime: '2022-03-23T13:22:26.182877+00:00',
          formUrlKey: 'fe532126-76e9-4de4-b1ed-26b04b67fae3',
          clientSource: '2',
          formTplId: 362,
          id: 598208,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?fe532126-76e9-4de4-b1ed-26b04b67fae3',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/?fe532126-76e9-4de4-b1ed-26b04b67fae3',
        },
        {
          totalPrice: 37467.62,
          orderPaymentStatus: -1,
          createTime: '2022-03-23T13:26:06.124395+00:00',
          formUrlKey: '4ed85d9d-a1a7-49f8-a54e-ae2fbde8d88f',
          clientSource: '2',
          formTplId: 361,
          id: 598209,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_mod/edit/?4ed85d9d-a1a7-49f8-a54e-ae2fbde8d88f',
          invoicePaymentStatus: 2,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_mod/?4ed85d9d-a1a7-49f8-a54e-ae2fbde8d88f',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2022-04-12T04:00:00+00:00',
      requestId: 12789727,
    },
    {
      invoices: [
        {
          totalPrice: 37467.62,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/29161',
          createTime: '2022-03-23T13:09:10.195778+00:00',
          formUrlKey: 'b8da81eb-d998-4890-a823-ea4539a74406',
          clientSource: '2',
          formTplId: 359,
          id: 598205,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs/edit/?b8da81eb-d998-4890-a823-ea4539a74406',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs/?b8da81eb-d998-4890-a823-ea4539a74406',
        },
        {
          totalPrice: 37467.62,
          orderPaymentStatus: 5,
          orderUrl: 'http://localhost:3000/sales/orders/29164',
          createTime: '2022-03-23T13:22:26.182877+00:00',
          formUrlKey: 'fe532126-76e9-4de4-b1ed-26b04b67fae3',
          clientSource: '2',
          formTplId: 362,
          id: 598208,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/edit/?fe532126-76e9-4de4-b1ed-26b04b67fae3',
          invoicePaymentStatus: 4,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_add_terms/?fe532126-76e9-4de4-b1ed-26b04b67fae3',
        },
        {
          totalPrice: 37467.62,
          orderPaymentStatus: -1,
          createTime: '2022-03-23T13:26:06.124395+00:00',
          formUrlKey: '4ed85d9d-a1a7-49f8-a54e-ae2fbde8d88f',
          clientSource: '2',
          formTplId: 361,
          id: 598209,
          formEditUrl:
            'https://console.vista.studio/forms/xcharterjs_mod/edit/?4ed85d9d-a1a7-49f8-a54e-ae2fbde8d88f',
          invoicePaymentStatus: 2,
          formUrl:
            'https://console.vista.studio/forms/xcharterjs_mod/?4ed85d9d-a1a7-49f8-a54e-ae2fbde8d88f',
        },
      ],
      lastOrder: {
        orderItems: null,
      },
      conciergeAction: 1,
      departureDate: '2022-03-27T22:10:09+00:00',
      requestId: 12789727,
    },
  ],
};
